import { url } from 'inspector';
import { API_URL, } from './Config';
import React, { useEffect, useState } from 'react';


export const colorsRange = (valores: number[], valor: number, codigo: string) => {
    const minColor = [230, 230, 250]; // Color mínimo (lavanda)
    const maxColor = [123, 44, 191]; // Color máximo (púrpura oscuro)
    const casiBlanco = [240, 240, 250];

    const cantidadMinima = Math.min(...valores);
    const cantidadMaxima = Math.max(...valores);
    const range = cantidadMaxima - cantidadMinima;

    if (cantidadMinima === cantidadMaxima && cantidadMinima > 0) {
        return maxColor;
    }
    else {
        if (cantidadMinima === cantidadMaxima && cantidadMinima == 0) {
            return casiBlanco;
        }
    }
    if(valor==0){
        return casiBlanco;
    }

    const color = valor === cantidadMinima ? minColor : valor === cantidadMaxima ? maxColor : [
        minColor[0] + Math.round((maxColor[0] - minColor[0]) * (valor - cantidadMinima) / range),
        minColor[1] + Math.round((maxColor[1] - minColor[1]) * (valor - cantidadMinima) / range),
        minColor[2] + Math.round((maxColor[2] - minColor[2]) * (valor - cantidadMinima) / range)
    ];
    return color;
};

export const colorsRangeHex = (valores: number[], valor: number, codigo: string) => {
    const color = colorsRange(valores, valor, codigo);
    return `#${color.map(c => c.toString(16).padStart(2, '0')).join('')}`;
}

export const formatNumber = (value: number | string, decimales: number = 2): string => {
    if (typeof value !== 'number') {
        value = parseFloat(value);
        if (isNaN(value)) {
            return '0';
        }
    }
    if (value < 0.01 && value > 0.0) {
        decimales = 3;
    }
    const cadenaValue = value.toFixed(decimales).toString();
    const partes = cadenaValue.split('.');
    let parteEntera = partes[0];
    const parteDecimal = partes.length > 1 ? partes[1] : '';
    parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // No mostrar decimales si es 0 el decimal
    if (parteDecimal === '00') {
        return parteEntera;
    }
    return parteEntera + (parteDecimal ? ',' + parteDecimal : '');
};


export const formatNumber2 = (value: number | string, decimales: number = 2): string => {
    if (typeof value !== 'number') {
        value = parseFloat(value);
        if (isNaN(value)) {
            return '0';
        }
    }
    if (value < 0.01 && value > 0.0) {
        decimales = 3;
    }
    const cadenaValue = value.toFixed(decimales).toString();
    const partes = cadenaValue.split('.');
    let parteEntera = partes[0];
    const parteDecimal = partes.length > 1 ? partes[1] : '';
    parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // No mostrar decimales si es 0 el decimal
    if (parteDecimal === '00') {
        return parteEntera;
    }
    return parteEntera + (parteDecimal ? ',' + parteDecimal : '');
};

/*
export const layerConfig = {
    departamentos: {
        fieldCode: "DPTO",
        fieldName: "NOMBRE_DPT",        
        url: "https://services3.arcgis.com/RNw3MQnfcqGgYg0A/arcgis/rest/services/departamentos_data/FeatureServer"
    },
    municipios: {
        fieldCode: "DPTOMPIO",
        fieldName: "MPIO_CNMBR",        
        url: "https://services3.arcgis.com/RNw3MQnfcqGgYg0A/arcgis/rest/services/municipios_data/FeatureServer"
    },
    pdetregiones:
    {
        fieldCode: "OBJECTID",
        fieldName: "PDET",        
        url: "https://services3.arcgis.com/RNw3MQnfcqGgYg0A/arcgis/rest/services/pdetregion_data/FeatureServer"
    },
    pdetmunicipios:
    {
        fieldCode: "OBJECTID",
        fieldName: "PDET",        
        url: "https://services3.arcgis.com/RNw3MQnfcqGgYg0A/arcgis/rest/services/pdetmunicipios_data/FeatureServer"
    }
};
*/

export const layerConfig = {
    departamentos: {
        fieldCode: "dpto",
        fieldName: "nombre_dpt",
        url: "https://mapasdnp.dnp.gov.co/server/rest/services/Hosted/departamentos_data_san_andres_cerca/FeatureServer/0"
    },
    municipios: {
        fieldCode: "dptompio",
        fieldName: "mpio_cnmbr",
        url: "https://mapasdnp.dnp.gov.co/server/rest/services/Hosted/municipios_nuevobelen/FeatureServer/0"
    },
    pdetregiones:
    {
        fieldCode: "objectid",
        fieldName: "pdet",
        url: "https://mapasdnp.dnp.gov.co/server/rest/services/Hosted/pdetregion_data_codigo_ajustado/FeatureServer/0"
    },
    pdetmunicipios:
    {
        fieldCode: "objectid",
        fieldName: "pdet",
        url: "https://mapasdnp.dnp.gov.co/server/rest/services/Hosted/pdetregion_data/FeatureServer/0"
    }
};

/*
WITH formatted AS (
  SELECT 
    '    { Tipo: ''' || "Tipo" || ''', CodigoDivipola: ''' || "Codigo" || ''', Nombre: ''' || "Nombre" || ''' },' AS line
  FROM 
    public."TrvDivipola"
)
SELECT 
  'export const divipolas = [' AS start_line
UNION ALL
SELECT 
  line 
FROM 
  formatted
UNION ALL
SELECT 
  '];' AS end_line;
*/

export const divipolas = [
    { Tipo: 'Departamento', CodigoDivipola: '05', Nombre: 'ANTIOQUIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05002', Nombre: 'ABEJORRAL' },
    { Tipo: 'Municipio', CodigoDivipola: '85400', Nombre: 'TÁMARA' },
    { Tipo: 'Municipio', CodigoDivipola: '85410', Nombre: 'TAURAMENA' },
    { Tipo: 'Municipio', CodigoDivipola: '85430', Nombre: 'TRINIDAD' },
    { Tipo: 'Municipio', CodigoDivipola: '85440', Nombre: 'VILLANUEVA' },
    { Tipo: 'Municipio', CodigoDivipola: '86001', Nombre: 'MOCOA' },
    { Tipo: 'Municipio', CodigoDivipola: '05212', Nombre: 'COPACABANA' },
    { Tipo: 'Municipio', CodigoDivipola: '05234', Nombre: 'DABEIBA' },
    { Tipo: 'Municipio', CodigoDivipola: '05237', Nombre: 'DONMATÍAS' },
    { Tipo: 'Municipio', CodigoDivipola: '05240', Nombre: 'EBÉJICO' },
    { Tipo: 'Municipio', CodigoDivipola: '05250', Nombre: 'EL BAGRE' },
    { Tipo: 'Municipio', CodigoDivipola: '05264', Nombre: 'ENTRERRÍOS' },
    { Tipo: 'Municipio', CodigoDivipola: '05266', Nombre: 'ENVIGADO' },
    { Tipo: 'Municipio', CodigoDivipola: '05282', Nombre: 'FREDONIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05284', Nombre: 'FRONTINO' },
    { Tipo: 'Municipio', CodigoDivipola: '05306', Nombre: 'GIRALDO' },
    { Tipo: 'Municipio', CodigoDivipola: '05308', Nombre: 'GIRARDOTA' },
    { Tipo: 'Municipio', CodigoDivipola: '05310', Nombre: 'GÓMEZ PLATA' },
    { Tipo: 'Municipio', CodigoDivipola: '05313', Nombre: 'GRANADA' },
    { Tipo: 'Municipio', CodigoDivipola: '05315', Nombre: 'GUADALUPE' },
    { Tipo: 'Municipio', CodigoDivipola: '05318', Nombre: 'GUARNE' },
    { Tipo: 'Municipio', CodigoDivipola: '05321', Nombre: 'GUATAPÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '05347', Nombre: 'HELICONIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05353', Nombre: 'HISPANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05360', Nombre: 'ITAGÜÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05361', Nombre: 'ITUANGO' },
    { Tipo: 'Municipio', CodigoDivipola: '05364', Nombre: 'JARDÍN' },
    { Tipo: 'Municipio', CodigoDivipola: '05368', Nombre: 'JERICÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '05376', Nombre: 'LA CEJA' },
    { Tipo: 'Municipio', CodigoDivipola: '05380', Nombre: 'LA ESTRELLA' },
    { Tipo: 'Municipio', CodigoDivipola: '05390', Nombre: 'LA PINTADA' },
    { Tipo: 'Municipio', CodigoDivipola: '05400', Nombre: 'LA UNIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '05411', Nombre: 'LIBORINA' },
    { Tipo: 'Municipio', CodigoDivipola: '05425', Nombre: 'MACEO' },
    { Tipo: 'Municipio', CodigoDivipola: '05440', Nombre: 'MARINILLA' },
    { Tipo: 'Municipio', CodigoDivipola: '05467', Nombre: 'MONTEBELLO' },
    { Tipo: 'Municipio', CodigoDivipola: '05475', Nombre: 'MURINDÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '05480', Nombre: 'MUTATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '05483', Nombre: 'NARIÑO' },
    { Tipo: 'Municipio', CodigoDivipola: '05490', Nombre: 'NECOCLÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05495', Nombre: 'NECHÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05501', Nombre: 'OLAYA' },
    { Tipo: 'Municipio', CodigoDivipola: '05541', Nombre: 'PEÑOL' },
    { Tipo: 'Municipio', CodigoDivipola: '05543', Nombre: 'PEQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '05576', Nombre: 'PUEBLORRICO' },
    { Tipo: 'Municipio', CodigoDivipola: '05579', Nombre: 'PUERTO BERRÍO' },
    { Tipo: 'Municipio', CodigoDivipola: '05585', Nombre: 'PUERTO NARE' },
    { Tipo: 'Municipio', CodigoDivipola: '05591', Nombre: 'PUERTO TRIUNFO' },
    { Tipo: 'Municipio', CodigoDivipola: '05604', Nombre: 'REMEDIOS' },
    { Tipo: 'Municipio', CodigoDivipola: '05607', Nombre: 'RETIRO' },
    { Tipo: 'Municipio', CodigoDivipola: '05615', Nombre: 'RIONEGRO' },
    { Tipo: 'Municipio', CodigoDivipola: '05628', Nombre: 'SABANALARGA' },
    { Tipo: 'Municipio', CodigoDivipola: '05631', Nombre: 'SABANETA' },
    { Tipo: 'Municipio', CodigoDivipola: '05642', Nombre: 'SALGAR' },
    { Tipo: 'Municipio', CodigoDivipola: '05647', Nombre: 'SAN ANDRÉS DE CUERQUÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '05649', Nombre: 'SAN CARLOS' },
    { Tipo: 'Municipio', CodigoDivipola: '05652', Nombre: 'SAN FRANCISCO' },
    { Tipo: 'Municipio', CodigoDivipola: '05656', Nombre: 'SAN JERÓNIMO' },
    { Tipo: 'Municipio', CodigoDivipola: '05658', Nombre: 'SAN JOSÉ DE LA MONTAÑA' },
    { Tipo: 'Municipio', CodigoDivipola: '05659', Nombre: 'SAN JUAN DE URABÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '05660', Nombre: 'SAN LUIS' },
    { Tipo: 'Municipio', CodigoDivipola: '05664', Nombre: 'SAN PEDRO DE LOS MILAGROS' },
    { Tipo: 'Municipio', CodigoDivipola: '05665', Nombre: 'SAN PEDRO DE URABÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '05667', Nombre: 'SAN RAFAEL' },
    { Tipo: 'Municipio', CodigoDivipola: '05670', Nombre: 'SAN ROQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '05674', Nombre: 'SAN VICENTE FERRER' },
    { Tipo: 'Municipio', CodigoDivipola: '05679', Nombre: 'SANTA BÁRBARA' },
    { Tipo: 'Municipio', CodigoDivipola: '05686', Nombre: 'SANTA ROSA DE OSOS' },
    { Tipo: 'Municipio', CodigoDivipola: '05690', Nombre: 'SANTO DOMINGO' },
    { Tipo: 'Municipio', CodigoDivipola: '05697', Nombre: 'EL SANTUARIO' },
    { Tipo: 'Municipio', CodigoDivipola: '05736', Nombre: 'SEGOVIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05756', Nombre: 'SONSÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '05761', Nombre: 'SOPETRÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '05789', Nombre: 'TÁMESIS' },
    { Tipo: 'Municipio', CodigoDivipola: '05790', Nombre: 'TARAZÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '05792', Nombre: 'TARSO' },
    { Tipo: 'Municipio', CodigoDivipola: '05809', Nombre: 'TITIRIBÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05819', Nombre: 'TOLEDO' },
    { Tipo: 'Municipio', CodigoDivipola: '05837', Nombre: 'TURBO' },
    { Tipo: 'Municipio', CodigoDivipola: '05842', Nombre: 'URAMITA' },
    { Tipo: 'Municipio', CodigoDivipola: '05847', Nombre: 'URRAO' },
    { Tipo: 'Municipio', CodigoDivipola: '05854', Nombre: 'VALDIVIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05856', Nombre: 'VALPARAÍSO' },
    { Tipo: 'Municipio', CodigoDivipola: '05858', Nombre: 'VEGACHÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05861', Nombre: 'VENECIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05873', Nombre: 'VIGÍA DEL FUERTE' },
    { Tipo: 'Municipio', CodigoDivipola: '05885', Nombre: 'YALÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05887', Nombre: 'YARUMAL' },
    { Tipo: 'Municipio', CodigoDivipola: '05890', Nombre: 'YOLOMBÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '05893', Nombre: 'YONDÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '05895', Nombre: 'ZARAGOZA' },
    { Tipo: 'Municipio', CodigoDivipola: '08001', Nombre: 'BARRANQUILLA' },
    { Tipo: 'Municipio', CodigoDivipola: '08078', Nombre: 'BARANOA' },
    { Tipo: 'Municipio', CodigoDivipola: '08137', Nombre: 'CAMPO DE LA CRUZ' },
    { Tipo: 'Municipio', CodigoDivipola: '08141', Nombre: 'CANDELARIA' },
    { Tipo: 'Municipio', CodigoDivipola: '08296', Nombre: 'GALAPA' },
    { Tipo: 'Municipio', CodigoDivipola: '08372', Nombre: 'JUAN DE ACOSTA' },
    { Tipo: 'Municipio', CodigoDivipola: '08421', Nombre: 'LURUACO' },
    { Tipo: 'Municipio', CodigoDivipola: '08433', Nombre: 'MALAMBO' },
    { Tipo: 'Municipio', CodigoDivipola: '08436', Nombre: 'MANATÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '08520', Nombre: 'PALMAR DE VARELA' },
    { Tipo: 'PdetRegion', CodigoDivipola: '02', Nombre: 'ARAUCA' },
    { Tipo: 'Departamento', CodigoDivipola: '11', Nombre: 'BOGOTÁ. D.C.' },
    { Tipo: 'Departamento', CodigoDivipola: '08', Nombre: 'ATLÁNTICO' },
    { Tipo: 'Departamento', CodigoDivipola: '13', Nombre: 'BOLÍVAR' },
    { Tipo: 'Departamento', CodigoDivipola: '15', Nombre: 'BOYACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '08549', Nombre: 'PIOJÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '08558', Nombre: 'POLONUEVO' },
    { Tipo: 'Municipio', CodigoDivipola: '08560', Nombre: 'PONEDERA' },
    { Tipo: 'Municipio', CodigoDivipola: '08573', Nombre: 'PUERTO COLOMBIA' },
    { Tipo: 'Municipio', CodigoDivipola: '08606', Nombre: 'REPELÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '08634', Nombre: 'SABANAGRANDE' },
    { Tipo: 'Municipio', CodigoDivipola: '08638', Nombre: 'SABANALARGA' },
    { Tipo: 'Municipio', CodigoDivipola: '08675', Nombre: 'SANTA LUCÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '08685', Nombre: 'SANTO TOMÁS' },
    { Tipo: 'Municipio', CodigoDivipola: '08758', Nombre: 'SOLEDAD' },
    { Tipo: 'Municipio', CodigoDivipola: '08770', Nombre: 'SUAN' },
    { Tipo: 'Municipio', CodigoDivipola: '08832', Nombre: 'TUBARÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '08849', Nombre: 'USIACURÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '11001', Nombre: 'BOGOTÁ. D.C.' },
    { Tipo: 'Municipio', CodigoDivipola: '13001', Nombre: 'CARTAGENA DE INDIAS' },
    { Tipo: 'Municipio', CodigoDivipola: '13006', Nombre: 'ACHÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '13030', Nombre: 'ALTOS DEL ROSARIO' },
    { Tipo: 'Municipio', CodigoDivipola: '13042', Nombre: 'ARENAL' },
    { Tipo: 'Municipio', CodigoDivipola: '13052', Nombre: 'ARJONA' },
    { Tipo: 'Municipio', CodigoDivipola: '13062', Nombre: 'ARROYOHONDO' },
    { Tipo: 'Municipio', CodigoDivipola: '13074', Nombre: 'BARRANCO DE LOBA' },
    { Tipo: 'Municipio', CodigoDivipola: '13140', Nombre: 'CALAMAR' },
    { Tipo: 'Municipio', CodigoDivipola: '13160', Nombre: 'CANTAGALLO' },
    { Tipo: 'Municipio', CodigoDivipola: '13188', Nombre: 'CICUCO' },
    { Tipo: 'Municipio', CodigoDivipola: '13212', Nombre: 'CÓRDOBA' },
    { Tipo: 'Municipio', CodigoDivipola: '13222', Nombre: 'CLEMENCIA' },
    { Tipo: 'Municipio', CodigoDivipola: '13244', Nombre: 'EL CARMEN DE BOLÍVAR' },
    { Tipo: 'Municipio', CodigoDivipola: '13248', Nombre: 'EL GUAMO' },
    { Tipo: 'Municipio', CodigoDivipola: '13268', Nombre: 'EL PEÑÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '13300', Nombre: 'HATILLO DE LOBA' },
    { Tipo: 'Municipio', CodigoDivipola: '13430', Nombre: 'MAGANGUÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '13433', Nombre: 'MAHATES' },
    { Tipo: 'Municipio', CodigoDivipola: '13440', Nombre: 'MARGARITA' },
    { Tipo: 'Municipio', CodigoDivipola: '13442', Nombre: 'MARÍA LA BAJA' },
    { Tipo: 'Municipio', CodigoDivipola: '13458', Nombre: 'MONTECRISTO' },
    { Tipo: 'Municipio', CodigoDivipola: '13468', Nombre: 'SANTA CRUZ DE MOMPOX' },
    { Tipo: 'Municipio', CodigoDivipola: '13473', Nombre: 'MORALES' },
    { Tipo: 'Municipio', CodigoDivipola: '13490', Nombre: 'NOROSÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '13549', Nombre: 'PINILLOS' },
    { Tipo: 'Municipio', CodigoDivipola: '13580', Nombre: 'REGIDOR' },
    { Tipo: 'Municipio', CodigoDivipola: '13600', Nombre: 'RÍO VIEJO' },
    { Tipo: 'Municipio', CodigoDivipola: '13620', Nombre: 'SAN CRISTÓBAL' },
    { Tipo: 'Municipio', CodigoDivipola: '13647', Nombre: 'SAN ESTANISLAO' },
    { Tipo: 'Municipio', CodigoDivipola: '13650', Nombre: 'SAN FERNANDO' },
    { Tipo: 'Municipio', CodigoDivipola: '13654', Nombre: 'SAN JACINTO' },
    { Tipo: 'Municipio', CodigoDivipola: '13655', Nombre: 'SAN JACINTO DEL CAUCA' },
    { Tipo: 'Municipio', CodigoDivipola: '13657', Nombre: 'SAN JUAN NEPOMUCENO' },
    { Tipo: 'Municipio', CodigoDivipola: '13667', Nombre: 'SAN MARTÍN DE LOBA' },
    { Tipo: 'Municipio', CodigoDivipola: '13670', Nombre: 'SAN PABLO' },
    { Tipo: 'Municipio', CodigoDivipola: '13673', Nombre: 'SANTA CATALINA' },
    { Tipo: 'Municipio', CodigoDivipola: '13683', Nombre: 'SANTA ROSA' },
    { Tipo: 'Municipio', CodigoDivipola: '13688', Nombre: 'SANTA ROSA DEL SUR' },
    { Tipo: 'Municipio', CodigoDivipola: '13744', Nombre: 'SIMITÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '13760', Nombre: 'SOPLAVIENTO' },
    { Tipo: 'Municipio', CodigoDivipola: '13780', Nombre: 'TALAIGUA NUEVO' },
    { Tipo: 'Municipio', CodigoDivipola: '13810', Nombre: 'TIQUISIO' },
    { Tipo: 'Municipio', CodigoDivipola: '13836', Nombre: 'TURBACO' },
    { Tipo: 'Municipio', CodigoDivipola: '13838', Nombre: 'TURBANÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '13873', Nombre: 'VILLANUEVA' },
    { Tipo: 'Municipio', CodigoDivipola: '13894', Nombre: 'ZAMBRANO' },
    { Tipo: 'Municipio', CodigoDivipola: '15001', Nombre: 'TUNJA' },
    { Tipo: 'Municipio', CodigoDivipola: '15022', Nombre: 'ALMEIDA' },
    { Tipo: 'Municipio', CodigoDivipola: '15047', Nombre: 'AQUITANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '15051', Nombre: 'ARCABUCO' },
    { Tipo: 'Municipio', CodigoDivipola: '15087', Nombre: 'BELÉN' },
    { Tipo: 'Municipio', CodigoDivipola: '15090', Nombre: 'BERBEO' },
    { Tipo: 'Municipio', CodigoDivipola: '15092', Nombre: 'BETÉITIVA' },
    { Tipo: 'Municipio', CodigoDivipola: '15097', Nombre: 'BOAVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15104', Nombre: 'BOYACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15106', Nombre: 'BRICEÑO' },
    { Tipo: 'Municipio', CodigoDivipola: '15109', Nombre: 'BUENAVISTA' },
    { Tipo: 'Municipio', CodigoDivipola: '15114', Nombre: 'BUSBANZÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15131', Nombre: 'CALDAS' },
    { Tipo: 'Municipio', CodigoDivipola: '15135', Nombre: 'CAMPOHERMOSO' },
    { Tipo: 'Municipio', CodigoDivipola: '15162', Nombre: 'CERINZA' },
    { Tipo: 'Municipio', CodigoDivipola: '15172', Nombre: 'CHINAVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15176', Nombre: 'CHIQUINQUIRÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15180', Nombre: 'CHISCAS' },
    { Tipo: 'Municipio', CodigoDivipola: '15183', Nombre: 'CHITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15185', Nombre: 'CHITARAQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '15187', Nombre: 'CHIVATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15189', Nombre: 'CIÉNEGA' },
    { Tipo: 'Municipio', CodigoDivipola: '15204', Nombre: 'CÓMBITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15212', Nombre: 'COPER' },
    { Tipo: 'Municipio', CodigoDivipola: '15215', Nombre: 'CORRALES' },
    { Tipo: 'Municipio', CodigoDivipola: '15218', Nombre: 'COVARACHÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '15223', Nombre: 'CUBARÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15224', Nombre: 'CUCAITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15226', Nombre: 'CUÍTIVA' },
    { Tipo: 'Municipio', CodigoDivipola: '15232', Nombre: 'CHÍQUIZA' },
    { Tipo: 'Municipio', CodigoDivipola: '15236', Nombre: 'CHIVOR' },
    { Tipo: 'Municipio', CodigoDivipola: '15238', Nombre: 'DUITAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '15244', Nombre: 'EL COCUY' },
    { Tipo: 'Municipio', CodigoDivipola: '15248', Nombre: 'EL ESPINO' },
    { Tipo: 'PdetRegion', CodigoDivipola: '07', Nombre: 'MACARENA - GUAVIARE' },
    { Tipo: 'PdetRegion', CodigoDivipola: '05', Nombre: 'CHOCÓ' },
    { Tipo: 'Departamento', CodigoDivipola: '17', Nombre: 'CALDAS' },
    { Tipo: 'Municipio', CodigoDivipola: '15500', Nombre: 'OICATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15507', Nombre: 'OTANCHE' },
    { Tipo: 'Municipio', CodigoDivipola: '15511', Nombre: 'PACHAVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15514', Nombre: 'PÁEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '15516', Nombre: 'PAIPA' },
    { Tipo: 'Municipio', CodigoDivipola: '15518', Nombre: 'PAJARITO' },
    { Tipo: 'Municipio', CodigoDivipola: '15522', Nombre: 'PANQUEBA' },
    { Tipo: 'Municipio', CodigoDivipola: '15531', Nombre: 'PAUNA' },
    { Tipo: 'Municipio', CodigoDivipola: '15533', Nombre: 'PAYA' },
    { Tipo: 'Municipio', CodigoDivipola: '15537', Nombre: 'PAZ DE RÍO' },
    { Tipo: 'Municipio', CodigoDivipola: '15542', Nombre: 'PESCA' },
    { Tipo: 'Municipio', CodigoDivipola: '15550', Nombre: 'PISBA' },
    { Tipo: 'Municipio', CodigoDivipola: '15572', Nombre: 'PUERTO BOYACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15580', Nombre: 'QUÍPAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '15599', Nombre: 'RAMIRIQUÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '15600', Nombre: 'RÁQUIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '15621', Nombre: 'RONDÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '15632', Nombre: 'SABOYÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15638', Nombre: 'SÁCHICA' },
    { Tipo: 'Municipio', CodigoDivipola: '15646', Nombre: 'SAMACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15660', Nombre: 'SAN EDUARDO' },
    { Tipo: 'Municipio', CodigoDivipola: '15664', Nombre: 'SAN JOSÉ DE PARE' },
    { Tipo: 'Municipio', CodigoDivipola: '15667', Nombre: 'SAN LUIS DE GACENO' },
    { Tipo: 'Municipio', CodigoDivipola: '15673', Nombre: 'SAN MATEO' },
    { Tipo: 'Municipio', CodigoDivipola: '15676', Nombre: 'SAN MIGUEL DE SEMA' },
    { Tipo: 'Municipio', CodigoDivipola: '15681', Nombre: 'SAN PABLO DE BORBUR' },
    { Tipo: 'Municipio', CodigoDivipola: '15686', Nombre: 'SANTANA' },
    { Tipo: 'Municipio', CodigoDivipola: '15690', Nombre: 'SANTA MARÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '15693', Nombre: 'SANTA ROSA DE VITERBO' },
    { Tipo: 'Municipio', CodigoDivipola: '15696', Nombre: 'SANTA SOFÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '15720', Nombre: 'SATIVANORTE' },
    { Tipo: 'Municipio', CodigoDivipola: '15723', Nombre: 'SATIVASUR' },
    { Tipo: 'Municipio', CodigoDivipola: '15740', Nombre: 'SIACHOQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '15753', Nombre: 'SOATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15755', Nombre: 'SOCOTÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15757', Nombre: 'SOCHA' },
    { Tipo: 'Municipio', CodigoDivipola: '15759', Nombre: 'SOGAMOSO' },
    { Tipo: 'Municipio', CodigoDivipola: '15272', Nombre: 'FIRAVITOBA' },
    { Tipo: 'Municipio', CodigoDivipola: '15276', Nombre: 'FLORESTA' },
    { Tipo: 'Municipio', CodigoDivipola: '15293', Nombre: 'GACHANTIVÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15296', Nombre: 'GÁMEZA' },
    { Tipo: 'Municipio', CodigoDivipola: '15299', Nombre: 'GARAGOA' },
    { Tipo: 'Municipio', CodigoDivipola: '15317', Nombre: 'GUACAMAYAS' },
    { Tipo: 'Municipio', CodigoDivipola: '15322', Nombre: 'GUATEQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '15325', Nombre: 'GUAYATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15332', Nombre: 'GÜICÁN DE LA SIERRA' },
    { Tipo: 'Municipio', CodigoDivipola: '15362', Nombre: 'IZA' },
    { Tipo: 'Municipio', CodigoDivipola: '15367', Nombre: 'JENESANO' },
    { Tipo: 'Municipio', CodigoDivipola: '15368', Nombre: 'JERICÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '15377', Nombre: 'LABRANZAGRANDE' },
    { Tipo: 'Municipio', CodigoDivipola: '15380', Nombre: 'LA CAPILLA' },
    { Tipo: 'Municipio', CodigoDivipola: '15401', Nombre: 'LA VICTORIA' },
    { Tipo: 'Municipio', CodigoDivipola: '15403', Nombre: 'LA UVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15407', Nombre: 'VILLA DE LEYVA' },
    { Tipo: 'Municipio', CodigoDivipola: '15425', Nombre: 'MACANAL' },
    { Tipo: 'Municipio', CodigoDivipola: '15442', Nombre: 'MARIPÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '15455', Nombre: 'MIRAFLORES' },
    { Tipo: 'Municipio', CodigoDivipola: '15464', Nombre: 'MONGUA' },
    { Tipo: 'Municipio', CodigoDivipola: '15466', Nombre: 'MONGUÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '15469', Nombre: 'MONIQUIRÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15476', Nombre: 'MOTAVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15480', Nombre: 'MUZO' },
    { Tipo: 'Municipio', CodigoDivipola: '15491', Nombre: 'NOBSA' },
    { Tipo: 'PdetRegion', CodigoDivipola: '10', Nombre: 'PACÍFICO Y FRONTERA NARIÑENSE' },
    { Tipo: 'PdetRegion', CodigoDivipola: '11', Nombre: 'PUTUMAYO' },
    { Tipo: 'PdetRegion', CodigoDivipola: '12', Nombre: 'SIERRA NEVADA - PERIJÁ' },
    { Tipo: 'PdetRegion', CodigoDivipola: '13', Nombre: 'SUR DE BOLÍVAR' },
    { Tipo: 'PdetRegion', CodigoDivipola: '14', Nombre: 'SUR DE CÓRDOBA' },
    { Tipo: 'PdetRegion', CodigoDivipola: '15', Nombre: 'SUR DEL TOLIMA' },
    { Tipo: 'PdetRegion', CodigoDivipola: '16', Nombre: 'URABÁ ANTIOQUEÑO' },
    { Tipo: 'PdetRegion', CodigoDivipola: '09', Nombre: 'PACÍFICO MEDIO' },
    { Tipo: 'Departamento', CodigoDivipola: '18', Nombre: 'CAQUETÁ' },
    { Tipo: 'Departamento', CodigoDivipola: '19', Nombre: 'CAUCA' },
    { Tipo: 'Departamento', CodigoDivipola: '20', Nombre: 'CESAR' },
    { Tipo: 'Departamento', CodigoDivipola: '23', Nombre: 'CÓRDOBA' },
    { Tipo: 'Municipio', CodigoDivipola: '15494', Nombre: 'NUEVO COLÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '15761', Nombre: 'SOMONDOCO' },
    { Tipo: 'Municipio', CodigoDivipola: '15762', Nombre: 'SORA' },
    { Tipo: 'Municipio', CodigoDivipola: '15763', Nombre: 'SOTAQUIRÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15764', Nombre: 'SORACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15774', Nombre: 'SUSACÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '15776', Nombre: 'SUTAMARCHÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '15778', Nombre: 'SUTATENZA' },
    { Tipo: 'Municipio', CodigoDivipola: '15790', Nombre: 'TASCO' },
    { Tipo: 'Municipio', CodigoDivipola: '15798', Nombre: 'TENZA' },
    { Tipo: 'Municipio', CodigoDivipola: '15804', Nombre: 'TIBANÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15806', Nombre: 'TIBASOSA' },
    { Tipo: 'Municipio', CodigoDivipola: '15808', Nombre: 'TINJACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15810', Nombre: 'TIPACOQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '15814', Nombre: 'TOCA' },
    { Tipo: 'Municipio', CodigoDivipola: '15816', Nombre: 'TOGÜÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '15820', Nombre: 'TÓPAGA' },
    { Tipo: 'Municipio', CodigoDivipola: '15822', Nombre: 'TOTA' },
    { Tipo: 'Municipio', CodigoDivipola: '15832', Nombre: 'TUNUNGUÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15835', Nombre: 'TURMEQUÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '15837', Nombre: 'TUTA' },
    { Tipo: 'Municipio', CodigoDivipola: '15839', Nombre: 'TUTAZÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15842', Nombre: 'ÚMBITA' },
    { Tipo: 'Municipio', CodigoDivipola: '15861', Nombre: 'VENTAQUEMADA' },
    { Tipo: 'Municipio', CodigoDivipola: '15879', Nombre: 'VIRACACHÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '15897', Nombre: 'ZETAQUIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '17001', Nombre: 'MANIZALES' },
    { Tipo: 'Municipio', CodigoDivipola: '17013', Nombre: 'AGUADAS' },
    { Tipo: 'Municipio', CodigoDivipola: '17042', Nombre: 'ANSERMA' },
    { Tipo: 'Municipio', CodigoDivipola: '17050', Nombre: 'ARANZAZU' },
    { Tipo: 'Municipio', CodigoDivipola: '17088', Nombre: 'BELALCÁZAR' },
    { Tipo: 'Municipio', CodigoDivipola: '17174', Nombre: 'CHINCHINÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '17272', Nombre: 'FILADELFIA' },
    { Tipo: 'Municipio', CodigoDivipola: '17380', Nombre: 'LA DORADA' },
    { Tipo: 'Municipio', CodigoDivipola: '17388', Nombre: 'LA MERCED' },
    { Tipo: 'Municipio', CodigoDivipola: '17433', Nombre: 'MANZANARES' },
    { Tipo: 'Municipio', CodigoDivipola: '17442', Nombre: 'MARMATO' },
    { Tipo: 'Municipio', CodigoDivipola: '17444', Nombre: 'MARQUETALIA' },
    { Tipo: 'Municipio', CodigoDivipola: '17446', Nombre: 'MARULANDA' },
    { Tipo: 'Municipio', CodigoDivipola: '17486', Nombre: 'NEIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '17495', Nombre: 'NORCASIA' },
    { Tipo: 'Municipio', CodigoDivipola: '17513', Nombre: 'PÁCORA' },
    { Tipo: 'Municipio', CodigoDivipola: '17524', Nombre: 'PALESTINA' },
    { Tipo: 'Municipio', CodigoDivipola: '17541', Nombre: 'PENSILVANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '17614', Nombre: 'RIOSUCIO' },
    { Tipo: 'Municipio', CodigoDivipola: '17616', Nombre: 'RISARALDA' },
    { Tipo: 'Municipio', CodigoDivipola: '17653', Nombre: 'SALAMINA' },
    { Tipo: 'Municipio', CodigoDivipola: '17662', Nombre: 'SAMANÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '17665', Nombre: 'SAN JOSÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '17777', Nombre: 'SUPÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '17867', Nombre: 'VICTORIA' },
    { Tipo: 'Municipio', CodigoDivipola: '17873', Nombre: 'VILLAMARÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '17877', Nombre: 'VITERBO' },
    { Tipo: 'Municipio', CodigoDivipola: '18001', Nombre: 'FLORENCIA' },
    { Tipo: 'Municipio', CodigoDivipola: '18029', Nombre: 'ALBANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '18094', Nombre: 'BELÉN DE LOS ANDAQUÍES' },
    { Tipo: 'Municipio', CodigoDivipola: '18150', Nombre: 'CARTAGENA DEL CHAIRÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '18205', Nombre: 'CURILLO' },
    { Tipo: 'Municipio', CodigoDivipola: '18247', Nombre: 'EL DONCELLO' },
    { Tipo: 'Municipio', CodigoDivipola: '18256', Nombre: 'EL PAUJÍL' },
    { Tipo: 'Municipio', CodigoDivipola: '18410', Nombre: 'LA MONTAÑITA' },
    { Tipo: 'Municipio', CodigoDivipola: '18460', Nombre: 'MILÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '18479', Nombre: 'MORELIA' },
    { Tipo: 'Municipio', CodigoDivipola: '18592', Nombre: 'PUERTO RICO' },
    { Tipo: 'Municipio', CodigoDivipola: '18610', Nombre: 'SAN JOSÉ DEL FRAGUA' },
    { Tipo: 'Municipio', CodigoDivipola: '18753', Nombre: 'SAN VICENTE DEL CAGUÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '18756', Nombre: 'SOLANO' },
    { Tipo: 'Municipio', CodigoDivipola: '18785', Nombre: 'SOLITA' },
    { Tipo: 'Municipio', CodigoDivipola: '18860', Nombre: 'VALPARAÍSO' },
    { Tipo: 'Municipio', CodigoDivipola: '19001', Nombre: 'POPAYÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '19022', Nombre: 'ALMAGUER' },
    { Tipo: 'Municipio', CodigoDivipola: '19050', Nombre: 'ARGELIA' },
    { Tipo: 'Municipio', CodigoDivipola: '19075', Nombre: 'BALBOA' },
    { Tipo: 'Municipio', CodigoDivipola: '19100', Nombre: 'BOLÍVAR' },
    { Tipo: 'Municipio', CodigoDivipola: '19110', Nombre: 'BUENOS AIRES' },
    { Tipo: 'Municipio', CodigoDivipola: '19130', Nombre: 'CAJIBÍO' },
    { Tipo: 'Municipio', CodigoDivipola: '19137', Nombre: 'CALDONO' },
    { Tipo: 'Municipio', CodigoDivipola: '19142', Nombre: 'CALOTO' },
    { Tipo: 'Municipio', CodigoDivipola: '19212', Nombre: 'CORINTO' },
    { Tipo: 'Municipio', CodigoDivipola: '19256', Nombre: 'EL TAMBO' },
    { Tipo: 'Municipio', CodigoDivipola: '19290', Nombre: 'FLORENCIA' },
    { Tipo: 'Municipio', CodigoDivipola: '19300', Nombre: 'GUACHENÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '19318', Nombre: 'GUAPI' },
    { Tipo: 'Municipio', CodigoDivipola: '19355', Nombre: 'INZÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '19364', Nombre: 'JAMBALÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '19392', Nombre: 'LA SIERRA' },
    { Tipo: 'Municipio', CodigoDivipola: '19397', Nombre: 'LA VEGA' },
    { Tipo: 'Municipio', CodigoDivipola: '19418', Nombre: 'LÓPEZ DE MICAY' },
    { Tipo: 'Municipio', CodigoDivipola: '19450', Nombre: 'MERCADERES' },
    { Tipo: 'Municipio', CodigoDivipola: '19455', Nombre: 'MIRANDA' },
    { Tipo: 'Municipio', CodigoDivipola: '19473', Nombre: 'MORALES' },
    { Tipo: 'Municipio', CodigoDivipola: '19513', Nombre: 'PADILLA' },
    { Tipo: 'Municipio', CodigoDivipola: '19517', Nombre: 'PÁEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '19532', Nombre: 'PATÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '19533', Nombre: 'PIAMONTE' },
    { Tipo: 'Municipio', CodigoDivipola: '19548', Nombre: 'PIENDAMÓ - TUNÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '19573', Nombre: 'PUERTO TEJADA' },
    { Tipo: 'Municipio', CodigoDivipola: '19585', Nombre: 'PURACÉ' },
    { Tipo: 'Departamento', CodigoDivipola: '25', Nombre: 'CUNDINAMARCA' },
    { Tipo: 'Municipio', CodigoDivipola: '25430', Nombre: 'MADRID' },
    { Tipo: 'Municipio', CodigoDivipola: '25436', Nombre: 'MANTA' },
    { Tipo: 'Municipio', CodigoDivipola: '25438', Nombre: 'MEDINA' },
    { Tipo: 'Municipio', CodigoDivipola: '25473', Nombre: 'MOSQUERA' },
    { Tipo: 'Municipio', CodigoDivipola: '25483', Nombre: 'NARIÑO' },
    { Tipo: 'Municipio', CodigoDivipola: '25486', Nombre: 'NEMOCÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '25488', Nombre: 'NILO' },
    { Tipo: 'Municipio', CodigoDivipola: '25489', Nombre: 'NIMAIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25491', Nombre: 'NOCAIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25506', Nombre: 'VENECIA' },
    { Tipo: 'Municipio', CodigoDivipola: '25513', Nombre: 'PACHO' },
    { Tipo: 'Municipio', CodigoDivipola: '25518', Nombre: 'PAIME' },
    { Tipo: 'Municipio', CodigoDivipola: '25524', Nombre: 'PANDI' },
    { Tipo: 'Municipio', CodigoDivipola: '25530', Nombre: 'PARATEBUENO' },
    { Tipo: 'Municipio', CodigoDivipola: '25535', Nombre: 'PASCA' },
    { Tipo: 'Municipio', CodigoDivipola: '25572', Nombre: 'PUERTO SALGAR' },
    { Tipo: 'Municipio', CodigoDivipola: '25580', Nombre: 'PULÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '25592', Nombre: 'QUEBRADANEGRA' },
    { Tipo: 'Municipio', CodigoDivipola: '25594', Nombre: 'QUETAME' },
    { Tipo: 'Municipio', CodigoDivipola: '25596', Nombre: 'QUIPILE' },
    { Tipo: 'Municipio', CodigoDivipola: '25599', Nombre: 'APULO' },
    { Tipo: 'Municipio', CodigoDivipola: '25612', Nombre: 'RICAURTE' },
    { Tipo: 'Municipio', CodigoDivipola: '25645', Nombre: 'SAN ANTONIO DEL TEQUENDAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25649', Nombre: 'SAN BERNARDO' },
    { Tipo: 'Municipio', CodigoDivipola: '25653', Nombre: 'SAN CAYETANO' },
    { Tipo: 'Municipio', CodigoDivipola: '25658', Nombre: 'SAN FRANCISCO' },
    { Tipo: 'Municipio', CodigoDivipola: '25662', Nombre: 'SAN JUAN DE RIOSECO' },
    { Tipo: 'Municipio', CodigoDivipola: '19622', Nombre: 'ROSAS' },
    { Tipo: 'Municipio', CodigoDivipola: '19693', Nombre: 'SAN SEBASTIÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '19698', Nombre: 'SANTANDER DE QUILICHAO' },
    { Tipo: 'Municipio', CodigoDivipola: '19701', Nombre: 'SANTA ROSA' },
    { Tipo: 'Municipio', CodigoDivipola: '19743', Nombre: 'SILVIA' },
    { Tipo: 'Municipio', CodigoDivipola: '19760', Nombre: 'SOTARÁ PAISPAMBA' },
    { Tipo: 'Municipio', CodigoDivipola: '19780', Nombre: 'SUÁREZ' },
    { Tipo: 'Municipio', CodigoDivipola: '19785', Nombre: 'SUCRE' },
    { Tipo: 'Municipio', CodigoDivipola: '19807', Nombre: 'TIMBÍO' },
    { Tipo: 'Municipio', CodigoDivipola: '19809', Nombre: 'TIMBIQUÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '19821', Nombre: 'TORIBÍO' },
    { Tipo: 'Municipio', CodigoDivipola: '19824', Nombre: 'TOTORÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '19845', Nombre: 'VILLA RICA' },
    { Tipo: 'Municipio', CodigoDivipola: '20001', Nombre: 'VALLEDUPAR' },
    { Tipo: 'Municipio', CodigoDivipola: '20011', Nombre: 'AGUACHICA' },
    { Tipo: 'Municipio', CodigoDivipola: '20013', Nombre: 'AGUSTÍN CODAZZI' },
    { Tipo: 'Municipio', CodigoDivipola: '20032', Nombre: 'ASTREA' },
    { Tipo: 'Municipio', CodigoDivipola: '20045', Nombre: 'BECERRIL' },
    { Tipo: 'Municipio', CodigoDivipola: '20060', Nombre: 'BOSCONIA' },
    { Tipo: 'Municipio', CodigoDivipola: '20175', Nombre: 'CHIMICHAGUA' },
    { Tipo: 'Municipio', CodigoDivipola: '20178', Nombre: 'CHIRIGUANÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '20228', Nombre: 'CURUMANÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '20238', Nombre: 'EL COPEY' },
    { Tipo: 'Municipio', CodigoDivipola: '20250', Nombre: 'EL PASO' },
    { Tipo: 'Municipio', CodigoDivipola: '20295', Nombre: 'GAMARRA' },
    { Tipo: 'Municipio', CodigoDivipola: '20310', Nombre: 'GONZÁLEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '20383', Nombre: 'LA GLORIA' },
    { Tipo: 'Municipio', CodigoDivipola: '20400', Nombre: 'LA JAGUA DE IBIRICO' },
    { Tipo: 'Municipio', CodigoDivipola: '20443', Nombre: 'MANAURE BALCÓN DEL CESAR' },
    { Tipo: 'Municipio', CodigoDivipola: '20517', Nombre: 'PAILITAS' },
    { Tipo: 'Municipio', CodigoDivipola: '20550', Nombre: 'PELAYA' },
    { Tipo: 'Municipio', CodigoDivipola: '20570', Nombre: 'PUEBLO BELLO' },
    { Tipo: 'Municipio', CodigoDivipola: '20614', Nombre: 'RÍO DE ORO' },
    { Tipo: 'Municipio', CodigoDivipola: '20621', Nombre: 'LA PAZ' },
    { Tipo: 'Municipio', CodigoDivipola: '20710', Nombre: 'SAN ALBERTO' },
    { Tipo: 'Municipio', CodigoDivipola: '20750', Nombre: 'SAN DIEGO' },
    { Tipo: 'Municipio', CodigoDivipola: '20770', Nombre: 'SAN MARTÍN' },
    { Tipo: 'Municipio', CodigoDivipola: '20787', Nombre: 'TAMALAMEQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '23001', Nombre: 'MONTERÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '23068', Nombre: 'AYAPEL' },
    { Tipo: 'Municipio', CodigoDivipola: '23079', Nombre: 'BUENAVISTA' },
    { Tipo: 'Municipio', CodigoDivipola: '23090', Nombre: 'CANALETE' },
    { Tipo: 'Municipio', CodigoDivipola: '23162', Nombre: 'CERETÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '23168', Nombre: 'CHIMÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '23182', Nombre: 'CHINÚ' },
    { Tipo: 'Municipio', CodigoDivipola: '23189', Nombre: 'CIÉNAGA DE ORO' },
    { Tipo: 'PdetRegion', CodigoDivipola: '06', Nombre: 'CUENCA DEL CAGUÁN Y PIEDEMONTE CAQUETEÑO' },
    { Tipo: 'PdetRegion', CodigoDivipola: '04', Nombre: 'CATATUMBO' },
    { Tipo: 'PdetRegion', CodigoDivipola: '08', Nombre: 'MONTES DE MARÍA' },
    { Tipo: 'PdetRegion', CodigoDivipola: '03', Nombre: 'BAJO CAUCA Y NORDESTE ANTIOQUEÑO' },
    { Tipo: 'PdetRegion', CodigoDivipola: '01', Nombre: 'ALTO PATÍA Y NORTE DEL CAUCA' },
    { Tipo: 'Departamento', CodigoDivipola: '27', Nombre: 'CHOCÓ' },
    { Tipo: 'Departamento', CodigoDivipola: '41', Nombre: 'HUILA' },
    { Tipo: 'Departamento', CodigoDivipola: '44', Nombre: 'LA GUAJIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '23300', Nombre: 'COTORRA' },
    { Tipo: 'Municipio', CodigoDivipola: '23350', Nombre: 'LA APARTADA' },
    { Tipo: 'Municipio', CodigoDivipola: '23417', Nombre: 'LORICA' },
    { Tipo: 'Municipio', CodigoDivipola: '23419', Nombre: 'LOS CÓRDOBAS' },
    { Tipo: 'Municipio', CodigoDivipola: '23464', Nombre: 'MOMIL' },
    { Tipo: 'Municipio', CodigoDivipola: '23466', Nombre: 'MONTELÍBANO' },
    { Tipo: 'Municipio', CodigoDivipola: '23500', Nombre: 'MOÑITOS' },
    { Tipo: 'Municipio', CodigoDivipola: '23555', Nombre: 'PLANETA RICA' },
    { Tipo: 'Municipio', CodigoDivipola: '23570', Nombre: 'PUEBLO NUEVO' },
    { Tipo: 'Municipio', CodigoDivipola: '23574', Nombre: 'PUERTO ESCONDIDO' },
    { Tipo: 'Municipio', CodigoDivipola: '23580', Nombre: 'PUERTO LIBERTADOR' },
    { Tipo: 'Municipio', CodigoDivipola: '23586', Nombre: 'PURÍSIMA DE LA CONCEPCIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '23660', Nombre: 'SAHAGÚN' },
    { Tipo: 'Municipio', CodigoDivipola: '23670', Nombre: 'SAN ANDRÉS DE SOTAVENTO' },
    { Tipo: 'Municipio', CodigoDivipola: '23672', Nombre: 'SAN ANTERO' },
    { Tipo: 'Municipio', CodigoDivipola: '23675', Nombre: 'SAN BERNARDO DEL VIENTO' },
    { Tipo: 'Municipio', CodigoDivipola: '23678', Nombre: 'SAN CARLOS' },
    { Tipo: 'Municipio', CodigoDivipola: '23682', Nombre: 'SAN JOSÉ DE URÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '23686', Nombre: 'SAN PELAYO' },
    { Tipo: 'Municipio', CodigoDivipola: '23807', Nombre: 'TIERRALTA' },
    { Tipo: 'Municipio', CodigoDivipola: '23815', Nombre: 'TUCHÍN' },
    { Tipo: 'Municipio', CodigoDivipola: '23855', Nombre: 'VALENCIA' },
    { Tipo: 'Municipio', CodigoDivipola: '25001', Nombre: 'AGUA DE DIOS' },
    { Tipo: 'Municipio', CodigoDivipola: '25019', Nombre: 'ALBÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '25035', Nombre: 'ANAPOIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25040', Nombre: 'ANOLAIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25053', Nombre: 'ARBELÁEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '25086', Nombre: 'BELTRÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '25095', Nombre: 'BITUIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25099', Nombre: 'BOJACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25120', Nombre: 'CABRERA' },
    { Tipo: 'Municipio', CodigoDivipola: '25123', Nombre: 'CACHIPAY' },
    { Tipo: 'Municipio', CodigoDivipola: '25126', Nombre: 'CAJICÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25148', Nombre: 'CAPARRAPÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '25151', Nombre: 'CÁQUEZA' },
    { Tipo: 'Municipio', CodigoDivipola: '25154', Nombre: 'CARMEN DE CARUPA' },
    { Tipo: 'Municipio', CodigoDivipola: '25168', Nombre: 'CHAGUANÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '25175', Nombre: 'CHÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '25178', Nombre: 'CHIPAQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '25181', Nombre: 'CHOACHÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '25183', Nombre: 'CHOCONTÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25200', Nombre: 'COGUA' },
    { Tipo: 'Municipio', CodigoDivipola: '25214', Nombre: 'COTA' },
    { Tipo: 'Municipio', CodigoDivipola: '25224', Nombre: 'CUCUNUBÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25245', Nombre: 'EL COLEGIO' },
    { Tipo: 'Municipio', CodigoDivipola: '25258', Nombre: 'EL PEÑÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '25260', Nombre: 'EL ROSAL' },
    { Tipo: 'Municipio', CodigoDivipola: '25269', Nombre: 'FACATATIVÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25279', Nombre: 'FÓMEQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '25281', Nombre: 'FOSCA' },
    { Tipo: 'Municipio', CodigoDivipola: '25286', Nombre: 'FUNZA' },
    { Tipo: 'Municipio', CodigoDivipola: '25288', Nombre: 'FÚQUENE' },
    { Tipo: 'Municipio', CodigoDivipola: '25290', Nombre: 'FUSAGASUGÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25293', Nombre: 'GACHALÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25295', Nombre: 'GACHANCIPÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25297', Nombre: 'GACHETÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25299', Nombre: 'GAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25307', Nombre: 'GIRARDOT' },
    { Tipo: 'Municipio', CodigoDivipola: '25312', Nombre: 'GRANADA' },
    { Tipo: 'Municipio', CodigoDivipola: '25317', Nombre: 'GUACHETÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25320', Nombre: 'GUADUAS' },
    { Tipo: 'Municipio', CodigoDivipola: '25322', Nombre: 'GUASCA' },
    { Tipo: 'Municipio', CodigoDivipola: '25324', Nombre: 'GUATAQUÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '25326', Nombre: 'GUATAVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '25328', Nombre: 'GUAYABAL DE SÍQUIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25335', Nombre: 'GUAYABETAL' },
    { Tipo: 'Municipio', CodigoDivipola: '25339', Nombre: 'GUTIÉRREZ' },
    { Tipo: 'Municipio', CodigoDivipola: '25368', Nombre: 'JERUSALÉN' },
    { Tipo: 'Municipio', CodigoDivipola: '25372', Nombre: 'JUNÍN' },
    { Tipo: 'Municipio', CodigoDivipola: '25377', Nombre: 'LA CALERA' },
    { Tipo: 'Municipio', CodigoDivipola: '25386', Nombre: 'LA MESA' },
    { Tipo: 'Municipio', CodigoDivipola: '25394', Nombre: 'LA PALMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25398', Nombre: 'LA PEÑA' },
    { Tipo: 'Municipio', CodigoDivipola: '25402', Nombre: 'LA VEGA' },
    { Tipo: 'Municipio', CodigoDivipola: '25407', Nombre: 'LENGUAZAQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '25426', Nombre: 'MACHETÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25718', Nombre: 'SASAIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25736', Nombre: 'SESQUILÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '25740', Nombre: 'SIBATÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '25743', Nombre: 'SILVANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '25745', Nombre: 'SIMIJACA' },
    { Tipo: 'Municipio', CodigoDivipola: '25754', Nombre: 'SOACHA' },
    { Tipo: 'Municipio', CodigoDivipola: '25758', Nombre: 'SOPÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '25769', Nombre: 'SUBACHOQUE' },
    { Tipo: 'Municipio', CodigoDivipola: '25772', Nombre: 'SUESCA' },
    { Tipo: 'Municipio', CodigoDivipola: '25777', Nombre: 'SUPATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25779', Nombre: 'SUSA' },
    { Tipo: 'Municipio', CodigoDivipola: '25781', Nombre: 'SUTATAUSA' },
    { Tipo: 'Municipio', CodigoDivipola: '25785', Nombre: 'TABIO' },
    { Tipo: 'Municipio', CodigoDivipola: '25793', Nombre: 'TAUSA' },
    { Tipo: 'Municipio', CodigoDivipola: '25797', Nombre: 'TENA' },
    { Tipo: 'Municipio', CodigoDivipola: '25799', Nombre: 'TENJO' },
    { Tipo: 'Municipio', CodigoDivipola: '25805', Nombre: 'TIBACUY' },
    { Tipo: 'Municipio', CodigoDivipola: '25807', Nombre: 'TIBIRITA' },
    { Tipo: 'Municipio', CodigoDivipola: '25815', Nombre: 'TOCAIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '25817', Nombre: 'TOCANCIPÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25823', Nombre: 'TOPAIPÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '25839', Nombre: 'UBALÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25841', Nombre: 'UBAQUE' },
    { Tipo: 'Departamento', CodigoDivipola: '47', Nombre: 'MAGDALENA' },
    { Tipo: 'Departamento', CodigoDivipola: '50', Nombre: 'META' },
    { Tipo: 'Departamento', CodigoDivipola: '52', Nombre: 'NARIÑO' },
    { Tipo: 'Municipio', CodigoDivipola: '25843', Nombre: 'VILLA DE SAN DIEGO DE UBATÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '25845', Nombre: 'UNE' },
    { Tipo: 'Municipio', CodigoDivipola: '25851', Nombre: 'ÚTICA' },
    { Tipo: 'Municipio', CodigoDivipola: '25862', Nombre: 'VERGARA' },
    { Tipo: 'Municipio', CodigoDivipola: '25867', Nombre: 'VIANÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '25871', Nombre: 'VILLAGÓMEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '25873', Nombre: 'VILLAPINZÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '25875', Nombre: 'VILLETA' },
    { Tipo: 'Municipio', CodigoDivipola: '25878', Nombre: 'VIOTÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '25885', Nombre: 'YACOPÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '25898', Nombre: 'ZIPACÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '25899', Nombre: 'ZIPAQUIRÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '27001', Nombre: 'QUIBDÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27006', Nombre: 'ACANDÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '27025', Nombre: 'ALTO BAUDÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27050', Nombre: 'ATRATO' },
    { Tipo: 'Municipio', CodigoDivipola: '27073', Nombre: 'BAGADÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27075', Nombre: 'BAHÍA SOLANO' },
    { Tipo: 'Municipio', CodigoDivipola: '27077', Nombre: 'BAJO BAUDÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27099', Nombre: 'BOJAYÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '27135', Nombre: 'EL CANTÓN DEL SAN PABLO' },
    { Tipo: 'Municipio', CodigoDivipola: '27150', Nombre: 'CARMEN DEL DARIÉN' },
    { Tipo: 'Municipio', CodigoDivipola: '27160', Nombre: 'CÉRTEGUI' },
    { Tipo: 'Municipio', CodigoDivipola: '27205', Nombre: 'CONDOTO' },
    { Tipo: 'Municipio', CodigoDivipola: '27245', Nombre: 'EL CARMEN DE ATRATO' },
    { Tipo: 'Municipio', CodigoDivipola: '27250', Nombre: 'EL LITORAL DEL SAN JUAN' },
    { Tipo: 'Municipio', CodigoDivipola: '27361', Nombre: 'ISTMINA' },
    { Tipo: 'Municipio', CodigoDivipola: '27372', Nombre: 'JURADÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27413', Nombre: 'LLORÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27425', Nombre: 'MEDIO ATRATO' },
    { Tipo: 'Municipio', CodigoDivipola: '27430', Nombre: 'MEDIO BAUDÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27450', Nombre: 'MEDIO SAN JUAN' },
    { Tipo: 'Municipio', CodigoDivipola: '27491', Nombre: 'NÓVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '27493', Nombre: 'NUEVO BELÉN DE BAJIRÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '27495', Nombre: 'NUQUÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '27580', Nombre: 'RÍO IRÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27600', Nombre: 'RÍO QUITO' },
    { Tipo: 'Municipio', CodigoDivipola: '27615', Nombre: 'RIOSUCIO' },
    { Tipo: 'Municipio', CodigoDivipola: '27660', Nombre: 'SAN JOSÉ DEL PALMAR' },
    { Tipo: 'Municipio', CodigoDivipola: '27745', Nombre: 'SIPÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '27787', Nombre: 'TADÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '27800', Nombre: 'UNGUÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '27810', Nombre: 'UNIÓN PANAMERICANA' },
    { Tipo: 'Municipio', CodigoDivipola: '41001', Nombre: 'NEIVA' },
    { Tipo: 'Municipio', CodigoDivipola: '41006', Nombre: 'ACEVEDO' },
    { Tipo: 'Municipio', CodigoDivipola: '41013', Nombre: 'AGRADO' },
    { Tipo: 'Municipio', CodigoDivipola: '41016', Nombre: 'AIPE' },
    { Tipo: 'Municipio', CodigoDivipola: '41020', Nombre: 'ALGECIRAS' },
    { Tipo: 'Municipio', CodigoDivipola: '41026', Nombre: 'ALTAMIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '41078', Nombre: 'BARAYA' },
    { Tipo: 'Municipio', CodigoDivipola: '41132', Nombre: 'CAMPOALEGRE' },
    { Tipo: 'Municipio', CodigoDivipola: '41206', Nombre: 'COLOMBIA' },
    { Tipo: 'Municipio', CodigoDivipola: '41244', Nombre: 'ELÍAS' },
    { Tipo: 'Municipio', CodigoDivipola: '41298', Nombre: 'GARZÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '41306', Nombre: 'GIGANTE' },
    { Tipo: 'Municipio', CodigoDivipola: '41319', Nombre: 'GUADALUPE' },
    { Tipo: 'Municipio', CodigoDivipola: '41349', Nombre: 'HOBO' },
    { Tipo: 'Municipio', CodigoDivipola: '41357', Nombre: 'ÍQUIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '41359', Nombre: 'ISNOS' },
    { Tipo: 'Municipio', CodigoDivipola: '41378', Nombre: 'LA ARGENTINA' },
    { Tipo: 'Municipio', CodigoDivipola: '41396', Nombre: 'LA PLATA' },
    { Tipo: 'Municipio', CodigoDivipola: '41483', Nombre: 'NÁTAGA' },
    { Tipo: 'Municipio', CodigoDivipola: '41503', Nombre: 'OPORAPA' },
    { Tipo: 'Municipio', CodigoDivipola: '41518', Nombre: 'PAICOL' },
    { Tipo: 'Municipio', CodigoDivipola: '41524', Nombre: 'PALERMO' },
    { Tipo: 'Municipio', CodigoDivipola: '41530', Nombre: 'PALESTINA' },
    { Tipo: 'Municipio', CodigoDivipola: '41548', Nombre: 'PITAL' },
    { Tipo: 'Municipio', CodigoDivipola: '41551', Nombre: 'PITALITO' },
    { Tipo: 'Municipio', CodigoDivipola: '41615', Nombre: 'RIVERA' },
    { Tipo: 'Municipio', CodigoDivipola: '41660', Nombre: 'SALADOBLANCO' },
    { Tipo: 'Municipio', CodigoDivipola: '41668', Nombre: 'SAN AGUSTÍN' },
    { Tipo: 'Municipio', CodigoDivipola: '41676', Nombre: 'SANTA MARÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '41770', Nombre: 'SUAZA' },
    { Tipo: 'Municipio', CodigoDivipola: '41791', Nombre: 'TARQUI' },
    { Tipo: 'Municipio', CodigoDivipola: '41797', Nombre: 'TESALIA' },
    { Tipo: 'Municipio', CodigoDivipola: '41799', Nombre: 'TELLO' },
    { Tipo: 'Municipio', CodigoDivipola: '41801', Nombre: 'TERUEL' },
    { Tipo: 'Municipio', CodigoDivipola: '41807', Nombre: 'TIMANÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '41872', Nombre: 'VILLAVIEJA' },
    { Tipo: 'Municipio', CodigoDivipola: '41885', Nombre: 'YAGUARÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '44001', Nombre: 'RIOHACHA' },
    { Tipo: 'Municipio', CodigoDivipola: '44035', Nombre: 'ALBANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '44078', Nombre: 'BARRANCAS' },
    { Tipo: 'Municipio', CodigoDivipola: '44090', Nombre: 'DIBULLA' },
    { Tipo: 'Municipio', CodigoDivipola: '44098', Nombre: 'DISTRACCIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '44110', Nombre: 'EL MOLINO' },
    { Tipo: 'Municipio', CodigoDivipola: '44279', Nombre: 'FONSECA' },
    { Tipo: 'Municipio', CodigoDivipola: '44378', Nombre: 'HATONUEVO' },
    { Tipo: 'Municipio', CodigoDivipola: '44420', Nombre: 'LA JAGUA DEL PILAR' },
    { Tipo: 'Municipio', CodigoDivipola: '44430', Nombre: 'MAICAO' },
    { Tipo: 'Municipio', CodigoDivipola: '44560', Nombre: 'MANAURE' },
    { Tipo: 'Municipio', CodigoDivipola: '44650', Nombre: 'SAN JUAN DEL CESAR' },
    { Tipo: 'Municipio', CodigoDivipola: '44847', Nombre: 'URIBIA' },
    { Tipo: 'Municipio', CodigoDivipola: '44855', Nombre: 'URUMITA' },
    { Tipo: 'Municipio', CodigoDivipola: '44874', Nombre: 'VILLANUEVA' },
    { Tipo: 'Municipio', CodigoDivipola: '47001', Nombre: 'SANTA MARTA' },
    { Tipo: 'Municipio', CodigoDivipola: '47030', Nombre: 'ALGARROBO' },
    { Tipo: 'Municipio', CodigoDivipola: '47053', Nombre: 'ARACATACA' },
    { Tipo: 'Municipio', CodigoDivipola: '47058', Nombre: 'ARIGUANÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '47161', Nombre: 'CERRO DE SAN ANTONIO' },
    { Tipo: 'Departamento', CodigoDivipola: '54', Nombre: 'NORTE DE SANTANDER' },
    { Tipo: 'Departamento', CodigoDivipola: '63', Nombre: 'QUINDÍO' },
    { Tipo: 'Departamento', CodigoDivipola: '66', Nombre: 'RISARALDA' },
    { Tipo: 'Departamento', CodigoDivipola: '68', Nombre: 'SANTANDER' },
    { Tipo: 'Municipio', CodigoDivipola: '52687', Nombre: 'SAN LORENZO' },
    { Tipo: 'Municipio', CodigoDivipola: '52693', Nombre: 'SAN PABLO' },
    { Tipo: 'Municipio', CodigoDivipola: '52694', Nombre: 'SAN PEDRO DE CARTAGO' },
    { Tipo: 'Municipio', CodigoDivipola: '52696', Nombre: 'SANTA BÁRBARA' },
    { Tipo: 'Municipio', CodigoDivipola: '52699', Nombre: 'SANTACRUZ' },
    { Tipo: 'Municipio', CodigoDivipola: '52720', Nombre: 'SAPUYES' },
    { Tipo: 'Municipio', CodigoDivipola: '52786', Nombre: 'TAMINANGO' },
    { Tipo: 'Municipio', CodigoDivipola: '52788', Nombre: 'TANGUA' },
    { Tipo: 'Municipio', CodigoDivipola: '52835', Nombre: 'SAN ANDRÉS DE TUMACO' },
    { Tipo: 'Municipio', CodigoDivipola: '52838', Nombre: 'TÚQUERRES' },
    { Tipo: 'Municipio', CodigoDivipola: '52885', Nombre: 'YACUANQUER' },
    { Tipo: 'Municipio', CodigoDivipola: '54001', Nombre: 'SAN JOSÉ DE CÚCUTA' },
    { Tipo: 'Municipio', CodigoDivipola: '47170', Nombre: 'CHIVOLO' },
    { Tipo: 'Municipio', CodigoDivipola: '47189', Nombre: 'CIÉNAGA' },
    { Tipo: 'Municipio', CodigoDivipola: '47205', Nombre: 'CONCORDIA' },
    { Tipo: 'Municipio', CodigoDivipola: '47245', Nombre: 'EL BANCO' },
    { Tipo: 'Municipio', CodigoDivipola: '47258', Nombre: 'EL PIÑÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '47268', Nombre: 'EL RETÉN' },
    { Tipo: 'Municipio', CodigoDivipola: '47288', Nombre: 'FUNDACIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '47318', Nombre: 'GUAMAL' },
    { Tipo: 'Municipio', CodigoDivipola: '47460', Nombre: 'NUEVA GRANADA' },
    { Tipo: 'Municipio', CodigoDivipola: '47541', Nombre: 'PEDRAZA' },
    { Tipo: 'Municipio', CodigoDivipola: '47545', Nombre: 'PIJIÑO DEL CARMEN' },
    { Tipo: 'Municipio', CodigoDivipola: '47551', Nombre: 'PIVIJAY' },
    { Tipo: 'Municipio', CodigoDivipola: '47555', Nombre: 'PLATO' },
    { Tipo: 'Municipio', CodigoDivipola: '47570', Nombre: 'PUEBLOVIEJO' },
    { Tipo: 'Municipio', CodigoDivipola: '47605', Nombre: 'REMOLINO' },
    { Tipo: 'Municipio', CodigoDivipola: '47660', Nombre: 'SABANAS DE SAN ÁNGEL' },
    { Tipo: 'Municipio', CodigoDivipola: '47675', Nombre: 'SALAMINA' },
    { Tipo: 'Municipio', CodigoDivipola: '47692', Nombre: 'SAN SEBASTIÁN DE BUENAVISTA' },
    { Tipo: 'Municipio', CodigoDivipola: '47703', Nombre: 'SAN ZENÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '47707', Nombre: 'SANTA ANA' },
    { Tipo: 'Municipio', CodigoDivipola: '47720', Nombre: 'SANTA BÁRBARA DE PINTO' },
    { Tipo: 'Municipio', CodigoDivipola: '47745', Nombre: 'SITIONUEVO' },
    { Tipo: 'Municipio', CodigoDivipola: '47798', Nombre: 'TENERIFE' },
    { Tipo: 'Municipio', CodigoDivipola: '47960', Nombre: 'ZAPAYÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '47980', Nombre: 'ZONA BANANERA' },
    { Tipo: 'Municipio', CodigoDivipola: '50001', Nombre: 'VILLAVICENCIO' },
    { Tipo: 'Municipio', CodigoDivipola: '50006', Nombre: 'ACACÍAS' },
    { Tipo: 'Municipio', CodigoDivipola: '50110', Nombre: 'BARRANCA DE UPÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '50124', Nombre: 'CABUYARO' },
    { Tipo: 'Municipio', CodigoDivipola: '50150', Nombre: 'CASTILLA LA NUEVA' },
    { Tipo: 'Municipio', CodigoDivipola: '50223', Nombre: 'CUBARRAL' },
    { Tipo: 'Municipio', CodigoDivipola: '50226', Nombre: 'CUMARAL' },
    { Tipo: 'Municipio', CodigoDivipola: '50245', Nombre: 'EL CALVARIO' },
    { Tipo: 'Municipio', CodigoDivipola: '50251', Nombre: 'EL CASTILLO' },
    { Tipo: 'Municipio', CodigoDivipola: '50270', Nombre: 'EL DORADO' },
    { Tipo: 'Municipio', CodigoDivipola: '50287', Nombre: 'FUENTE DE ORO' },
    { Tipo: 'Municipio', CodigoDivipola: '50313', Nombre: 'GRANADA' },
    { Tipo: 'Municipio', CodigoDivipola: '50318', Nombre: 'GUAMAL' },
    { Tipo: 'Municipio', CodigoDivipola: '50325', Nombre: 'MAPIRIPÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '50330', Nombre: 'MESETAS' },
    { Tipo: 'Municipio', CodigoDivipola: '50350', Nombre: 'LA MACARENA' },
    { Tipo: 'Municipio', CodigoDivipola: '50370', Nombre: 'URIBE' },
    { Tipo: 'Municipio', CodigoDivipola: '50400', Nombre: 'LEJANÍAS' },
    { Tipo: 'Municipio', CodigoDivipola: '50450', Nombre: 'PUERTO CONCORDIA' },
    { Tipo: 'Municipio', CodigoDivipola: '50568', Nombre: 'PUERTO GAITÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '50573', Nombre: 'PUERTO LÓPEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '50577', Nombre: 'PUERTO LLERAS' },
    { Tipo: 'Municipio', CodigoDivipola: '50590', Nombre: 'PUERTO RICO' },
    { Tipo: 'Municipio', CodigoDivipola: '50606', Nombre: 'RESTREPO' },
    { Tipo: 'Municipio', CodigoDivipola: '50680', Nombre: 'SAN CARLOS DE GUAROA' },
    { Tipo: 'Municipio', CodigoDivipola: '50683', Nombre: 'SAN JUAN DE ARAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '50686', Nombre: 'SAN JUANITO' },
    { Tipo: 'Municipio', CodigoDivipola: '50689', Nombre: 'SAN MARTÍN' },
    { Tipo: 'Municipio', CodigoDivipola: '50711', Nombre: 'VISTAHERMOSA' },
    { Tipo: 'Municipio', CodigoDivipola: '52001', Nombre: 'PASTO' },
    { Tipo: 'Municipio', CodigoDivipola: '52019', Nombre: 'ALBÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '52022', Nombre: 'ALDANA' },
    { Tipo: 'Municipio', CodigoDivipola: '52036', Nombre: 'ANCUYA' },
    { Tipo: 'Municipio', CodigoDivipola: '52051', Nombre: 'ARBOLEDA' },
    { Tipo: 'Municipio', CodigoDivipola: '52079', Nombre: 'BARBACOAS' },
    { Tipo: 'Municipio', CodigoDivipola: '52083', Nombre: 'BELÉN' },
    { Tipo: 'Municipio', CodigoDivipola: '52110', Nombre: 'BUESACO' },
    { Tipo: 'Municipio', CodigoDivipola: '52203', Nombre: 'COLÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '52207', Nombre: 'CONSACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '52210', Nombre: 'CONTADERO' },
    { Tipo: 'Municipio', CodigoDivipola: '52215', Nombre: 'CÓRDOBA' },
    { Tipo: 'Municipio', CodigoDivipola: '52224', Nombre: 'CUASPUD CARLOSAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '52227', Nombre: 'CUMBAL' },
    { Tipo: 'Municipio', CodigoDivipola: '52233', Nombre: 'CUMBITARA' },
    { Tipo: 'Municipio', CodigoDivipola: '52240', Nombre: 'CHACHAGÜÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19050', Nombre: 'ARGELIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19075', Nombre: 'BALBOA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19110', Nombre: 'BUENOS AIRES' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19130', Nombre: 'CAJIBÍO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19137', Nombre: 'CALDONO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19142', Nombre: 'CALOTO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19212', Nombre: 'CORINTO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19256', Nombre: 'EL TAMBO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19364', Nombre: 'JAMBALÓ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19450', Nombre: 'MERCADERES' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19455', Nombre: 'MIRANDA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19473', Nombre: 'MORALES' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19532', Nombre: 'PATÍA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19548', Nombre: 'PIENDAMÓ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19698', Nombre: 'SANTANDER DE QUILICHAO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19780', Nombre: 'SUÁREZ' },
    { Tipo: 'Departamento', CodigoDivipola: '70', Nombre: 'SUCRE' },
    { Tipo: 'Departamento', CodigoDivipola: '73', Nombre: 'TOLIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '52250', Nombre: 'EL CHARCO' },
    { Tipo: 'Municipio', CodigoDivipola: '52254', Nombre: 'EL PEÑOL' },
    { Tipo: 'Municipio', CodigoDivipola: '52256', Nombre: 'EL ROSARIO' },
    { Tipo: 'Municipio', CodigoDivipola: '52258', Nombre: 'EL TABLÓN DE GÓMEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '52260', Nombre: 'EL TAMBO' },
    { Tipo: 'Municipio', CodigoDivipola: '52287', Nombre: 'FUNES' },
    { Tipo: 'Municipio', CodigoDivipola: '52317', Nombre: 'GUACHUCAL' },
    { Tipo: 'Municipio', CodigoDivipola: '52320', Nombre: 'GUAITARILLA' },
    { Tipo: 'Municipio', CodigoDivipola: '52323', Nombre: 'GUALMATÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '52352', Nombre: 'ILES' },
    { Tipo: 'Municipio', CodigoDivipola: '52354', Nombre: 'IMUÉS' },
    { Tipo: 'Municipio', CodigoDivipola: '52356', Nombre: 'IPIALES' },
    { Tipo: 'Municipio', CodigoDivipola: '52378', Nombre: 'LA CRUZ' },
    { Tipo: 'Municipio', CodigoDivipola: '52381', Nombre: 'LA FLORIDA' },
    { Tipo: 'Municipio', CodigoDivipola: '52385', Nombre: 'LA LLANADA' },
    { Tipo: 'Municipio', CodigoDivipola: '52390', Nombre: 'LA TOLA' },
    { Tipo: 'Municipio', CodigoDivipola: '52399', Nombre: 'LA UNIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '52405', Nombre: 'LEIVA' },
    { Tipo: 'Municipio', CodigoDivipola: '52411', Nombre: 'LINARES' },
    { Tipo: 'Municipio', CodigoDivipola: '52418', Nombre: 'LOS ANDES' },
    { Tipo: 'Municipio', CodigoDivipola: '52427', Nombre: 'MAGÜÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '52435', Nombre: 'MALLAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '52473', Nombre: 'MOSQUERA' },
    { Tipo: 'Municipio', CodigoDivipola: '52480', Nombre: 'NARIÑO' },
    { Tipo: 'Municipio', CodigoDivipola: '52490', Nombre: 'OLAYA HERRERA' },
    { Tipo: 'Municipio', CodigoDivipola: '52506', Nombre: 'OSPINA' },
    { Tipo: 'Municipio', CodigoDivipola: '52520', Nombre: 'FRANCISCO PIZARRO' },
    { Tipo: 'Municipio', CodigoDivipola: '52540', Nombre: 'POLICARPA' },
    { Tipo: 'Municipio', CodigoDivipola: '52560', Nombre: 'POTOSÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '52565', Nombre: 'PROVIDENCIA' },
    { Tipo: 'Municipio', CodigoDivipola: '52573', Nombre: 'PUERRES' },
    { Tipo: 'Municipio', CodigoDivipola: '52585', Nombre: 'PUPIALES' },
    { Tipo: 'Municipio', CodigoDivipola: '52612', Nombre: 'RICAURTE' },
    { Tipo: 'Municipio', CodigoDivipola: '52621', Nombre: 'ROBERTO PAYÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '52678', Nombre: 'SAMANIEGO' },
    { Tipo: 'Municipio', CodigoDivipola: '52683', Nombre: 'SANDONÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '52685', Nombre: 'SAN BERNARDO' },
    { Tipo: 'Municipio', CodigoDivipola: '54003', Nombre: 'ÁBREGO' },
    { Tipo: 'Municipio', CodigoDivipola: '54051', Nombre: 'ARBOLEDAS' },
    { Tipo: 'Municipio', CodigoDivipola: '54099', Nombre: 'BOCHALEMA' },
    { Tipo: 'Municipio', CodigoDivipola: '54109', Nombre: 'BUCARASICA' },
    { Tipo: 'Municipio', CodigoDivipola: '54125', Nombre: 'CÁCOTA' },
    { Tipo: 'Municipio', CodigoDivipola: '54128', Nombre: 'CÁCHIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '54172', Nombre: 'CHINÁCOTA' },
    { Tipo: 'Municipio', CodigoDivipola: '54174', Nombre: 'CHITAGÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '54206', Nombre: 'CONVENCIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '54223', Nombre: 'CUCUTILLA' },
    { Tipo: 'Municipio', CodigoDivipola: '54239', Nombre: 'DURANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '54245', Nombre: 'EL CARMEN' },
    { Tipo: 'Municipio', CodigoDivipola: '54250', Nombre: 'EL TARRA' },
    { Tipo: 'Municipio', CodigoDivipola: '54261', Nombre: 'EL ZULIA' },
    { Tipo: 'Municipio', CodigoDivipola: '54313', Nombre: 'GRAMALOTE' },
    { Tipo: 'Municipio', CodigoDivipola: '54344', Nombre: 'HACARÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '54347', Nombre: 'HERRÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '54377', Nombre: 'LABATECA' },
    { Tipo: 'Municipio', CodigoDivipola: '54385', Nombre: 'LA ESPERANZA' },
    { Tipo: 'Municipio', CodigoDivipola: '54398', Nombre: 'LA PLAYA' },
    { Tipo: 'Municipio', CodigoDivipola: '54405', Nombre: 'LOS PATIOS' },
    { Tipo: 'Municipio', CodigoDivipola: '54418', Nombre: 'LOURDES' },
    { Tipo: 'Municipio', CodigoDivipola: '54480', Nombre: 'MUTISCUA' },
    { Tipo: 'Municipio', CodigoDivipola: '54498', Nombre: 'OCAÑA' },
    { Tipo: 'Municipio', CodigoDivipola: '54518', Nombre: 'PAMPLONA' },
    { Tipo: 'Municipio', CodigoDivipola: '54520', Nombre: 'PAMPLONITA' },
    { Tipo: 'Municipio', CodigoDivipola: '54553', Nombre: 'PUERTO SANTANDER' },
    { Tipo: 'Municipio', CodigoDivipola: '54599', Nombre: 'RAGONVALIA' },
    { Tipo: 'Municipio', CodigoDivipola: '54660', Nombre: 'SALAZAR' },
    { Tipo: 'Municipio', CodigoDivipola: '54670', Nombre: 'SAN CALIXTO' },
    { Tipo: 'Municipio', CodigoDivipola: '54673', Nombre: 'SAN CAYETANO' },
    { Tipo: 'Municipio', CodigoDivipola: '54680', Nombre: 'SANTIAGO' },
    { Tipo: 'Municipio', CodigoDivipola: '54720', Nombre: 'SARDINATA' },
    { Tipo: 'Municipio', CodigoDivipola: '54743', Nombre: 'SILOS' },
    { Tipo: 'Municipio', CodigoDivipola: '54800', Nombre: 'TEORAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '54810', Nombre: 'TIBÚ' },
    { Tipo: 'Municipio', CodigoDivipola: '54820', Nombre: 'TOLEDO' },
    { Tipo: 'Municipio', CodigoDivipola: '54871', Nombre: 'VILLA CARO' },
    { Tipo: 'Municipio', CodigoDivipola: '54874', Nombre: 'VILLA DEL ROSARIO' },
    { Tipo: 'Municipio', CodigoDivipola: '63001', Nombre: 'ARMENIA' },
    { Tipo: 'Municipio', CodigoDivipola: '63111', Nombre: 'BUENAVISTA' },
    { Tipo: 'Municipio', CodigoDivipola: '63130', Nombre: 'CALARCÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '63190', Nombre: 'CIRCASIA' },
    { Tipo: 'Municipio', CodigoDivipola: '63212', Nombre: 'CÓRDOBA' },
    { Tipo: 'Municipio', CodigoDivipola: '63272', Nombre: 'FILANDIA' },
    { Tipo: 'Municipio', CodigoDivipola: '63302', Nombre: 'GÉNOVA' },
    { Tipo: 'Municipio', CodigoDivipola: '63401', Nombre: 'LA TEBAIDA' },
    { Tipo: 'Municipio', CodigoDivipola: '63470', Nombre: 'MONTENEGRO' },
    { Tipo: 'Municipio', CodigoDivipola: '63548', Nombre: 'PIJAO' },
    { Tipo: 'Municipio', CodigoDivipola: '63594', Nombre: 'QUIMBAYA' },
    { Tipo: 'Municipio', CodigoDivipola: '63690', Nombre: 'SALENTO' },
    { Tipo: 'Municipio', CodigoDivipola: '66001', Nombre: 'PEREIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '66045', Nombre: 'APÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '66075', Nombre: 'BALBOA' },
    { Tipo: 'Municipio', CodigoDivipola: '66088', Nombre: 'BELÉN DE UMBRÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '66170', Nombre: 'DOSQUEBRADAS' },
    { Tipo: 'Municipio', CodigoDivipola: '66318', Nombre: 'GUÁTICA' },
    { Tipo: 'Municipio', CodigoDivipola: '66383', Nombre: 'LA CELIA' },
    { Tipo: 'Municipio', CodigoDivipola: '66400', Nombre: 'LA VIRGINIA' },
    { Tipo: 'Municipio', CodigoDivipola: '66440', Nombre: 'MARSELLA' },
    { Tipo: 'Municipio', CodigoDivipola: '66456', Nombre: 'MISTRATÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '66572', Nombre: 'PUEBLO RICO' },
    { Tipo: 'Municipio', CodigoDivipola: '66594', Nombre: 'QUINCHÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '66682', Nombre: 'SANTA ROSA DE CABAL' },
    { Tipo: 'Municipio', CodigoDivipola: '66687', Nombre: 'SANTUARIO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19821', Nombre: 'TORIBIO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52233', Nombre: 'CUMBITARA' },
    { Tipo: 'Departamento', CodigoDivipola: '76', Nombre: 'VALLE DEL CAUCA' },
    { Tipo: 'Departamento', CodigoDivipola: '81', Nombre: 'ARAUCA' },
    { Tipo: 'Departamento', CodigoDivipola: '85', Nombre: 'CASANARE' },
    { Tipo: 'Departamento', CodigoDivipola: '86', Nombre: 'PUTUMAYO' },
    { Tipo: 'Municipio', CodigoDivipola: '76306', Nombre: 'GINEBRA' },
    { Tipo: 'Municipio', CodigoDivipola: '76318', Nombre: 'GUACARÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '76364', Nombre: 'JAMUNDÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '76377', Nombre: 'LA CUMBRE' },
    { Tipo: 'Municipio', CodigoDivipola: '76400', Nombre: 'LA UNIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '76403', Nombre: 'LA VICTORIA' },
    { Tipo: 'Municipio', CodigoDivipola: '76497', Nombre: 'OBANDO' },
    { Tipo: 'Municipio', CodigoDivipola: '76520', Nombre: 'PALMIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '76563', Nombre: 'PRADERA' },
    { Tipo: 'Municipio', CodigoDivipola: '76606', Nombre: 'RESTREPO' },
    { Tipo: 'Municipio', CodigoDivipola: '76616', Nombre: 'RIOFRÍO' },
    { Tipo: 'Municipio', CodigoDivipola: '76622', Nombre: 'ROLDANILLO' },
    { Tipo: 'Municipio', CodigoDivipola: '76670', Nombre: 'SAN PEDRO' },
    { Tipo: 'Municipio', CodigoDivipola: '76736', Nombre: 'SEVILLA' },
    { Tipo: 'Municipio', CodigoDivipola: '76823', Nombre: 'TORO' },
    { Tipo: 'Municipio', CodigoDivipola: '76828', Nombre: 'TRUJILLO' },
    { Tipo: 'Municipio', CodigoDivipola: '76834', Nombre: 'TULUÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '76845', Nombre: 'ULLOA' },
    { Tipo: 'Municipio', CodigoDivipola: '76863', Nombre: 'VERSALLES' },
    { Tipo: 'Municipio', CodigoDivipola: '76869', Nombre: 'VIJES' },
    { Tipo: 'Municipio', CodigoDivipola: '76890', Nombre: 'YOTOCO' },
    { Tipo: 'Municipio', CodigoDivipola: '76892', Nombre: 'YUMBO' },
    { Tipo: 'Municipio', CodigoDivipola: '76895', Nombre: 'ZARZAL' },
    { Tipo: 'Municipio', CodigoDivipola: '81001', Nombre: 'ARAUCA' },
    { Tipo: 'Municipio', CodigoDivipola: '81065', Nombre: 'ARAUQUITA' },
    { Tipo: 'Municipio', CodigoDivipola: '81220', Nombre: 'CRAVO NORTE' },
    { Tipo: 'Municipio', CodigoDivipola: '81300', Nombre: 'FORTUL' },
    { Tipo: 'Municipio', CodigoDivipola: '81591', Nombre: 'PUERTO RONDÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '81736', Nombre: 'SARAVENA' },
    { Tipo: 'Municipio', CodigoDivipola: '81794', Nombre: 'TAME' },
    { Tipo: 'Municipio', CodigoDivipola: '85001', Nombre: 'YOPAL' },
    { Tipo: 'Municipio', CodigoDivipola: '85010', Nombre: 'AGUAZUL' },
    { Tipo: 'Municipio', CodigoDivipola: '85015', Nombre: 'CHÁMEZA' },
    { Tipo: 'Municipio', CodigoDivipola: '85125', Nombre: 'HATO COROZAL' },
    { Tipo: 'Municipio', CodigoDivipola: '85136', Nombre: 'LA SALINA' },
    { Tipo: 'Municipio', CodigoDivipola: '85139', Nombre: 'MANÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '85162', Nombre: 'MONTERREY' },
    { Tipo: 'Municipio', CodigoDivipola: '85225', Nombre: 'NUNCHÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '85230', Nombre: 'OROCUÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '85250', Nombre: 'PAZ DE ARIPORO' },
    { Tipo: 'Municipio', CodigoDivipola: '85263', Nombre: 'PORE' },
    { Tipo: 'Municipio', CodigoDivipola: '85279', Nombre: 'RECETOR' },
    { Tipo: 'Municipio', CodigoDivipola: '85300', Nombre: 'SABANALARGA' },
    { Tipo: 'Municipio', CodigoDivipola: '85315', Nombre: 'SÁCAMA' },
    { Tipo: 'Municipio', CodigoDivipola: '85325', Nombre: 'SAN LUIS DE PALENQUE' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52256', Nombre: 'EL ROSARIO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52405', Nombre: 'LEIVA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52418', Nombre: 'LOS ANDES' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52540', Nombre: 'POLICARPA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '76275', Nombre: 'FLORIDA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '76563', Nombre: 'PRADERA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '81065', Nombre: 'ARAUQUITA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '81300', Nombre: 'FORTUL' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '81736', Nombre: 'SARAVENA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '81794', Nombre: 'TAME' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '54206', Nombre: 'CONVENCIÓN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '54245', Nombre: 'EL CARMEN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '54250', Nombre: 'EL TARRA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '54344', Nombre: 'HACARÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '54670', Nombre: 'SAN CALIXTO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '54720', Nombre: 'SARDINATA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '54800', Nombre: 'TEORAMA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '54810', Nombre: 'TIBÚ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27006', Nombre: 'ACANDÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27099', Nombre: 'BOJAYA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27150', Nombre: 'CARMEN DEL DARIEN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27205', Nombre: 'CONDOTO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27250', Nombre: 'EL LITORAL DEL SAN JUAN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27361', Nombre: 'ISTMINA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27425', Nombre: 'MEDIO ATRATO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27450', Nombre: 'MEDIO SAN JUAN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27491', Nombre: 'NÓVITA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27615', Nombre: 'RIOSUCIO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27745', Nombre: 'SIPÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '27800', Nombre: 'UNGUÍA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18029', Nombre: 'ALBANIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18094', Nombre: 'BELÉN DE LOS ANDAQUÍES' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18150', Nombre: 'CARTAGENA DEL CHAIRÁ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18205', Nombre: 'CURILLO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18247', Nombre: 'EL DONCELLO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18256', Nombre: 'EL PAUJIL' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18001', Nombre: 'FLORENCIA' },
    { Tipo: 'Departamento', CodigoDivipola: '88', Nombre: 'ARCHIPIÉLAGO DE SAN ANDRÉS. PROVIDENCIA Y SANTA CATALINA' },
    { Tipo: 'Departamento', CodigoDivipola: '91', Nombre: 'AMAZONAS' },
    { Tipo: 'Departamento', CodigoDivipola: '94', Nombre: 'GUAINÍA' },
    { Tipo: 'Departamento', CodigoDivipola: '95', Nombre: 'GUAVIARE' },
    { Tipo: 'Departamento', CodigoDivipola: '97', Nombre: 'VAUPÉS' },
    { Tipo: 'Departamento', CodigoDivipola: '99', Nombre: 'VICHADA' },
    { Tipo: 'Nacional', CodigoDivipola: 'DESAGREGACIÓN', Nombre: 'NACIONAL' },
    { Tipo: 'Municipio', CodigoDivipola: '05004', Nombre: 'ABRIAQUÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05021', Nombre: 'ALEJANDRÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '05030', Nombre: 'AMAGÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '05031', Nombre: 'AMALFI' },
    { Tipo: 'Municipio', CodigoDivipola: '05034', Nombre: 'ANDES' },
    { Tipo: 'Municipio', CodigoDivipola: '05036', Nombre: 'ANGELÓPOLIS' },
    { Tipo: 'Municipio', CodigoDivipola: '05038', Nombre: 'ANGOSTURA' },
    { Tipo: 'Municipio', CodigoDivipola: '05040', Nombre: 'ANORÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05042', Nombre: 'SANTA FÉ DE ANTIOQUIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05044', Nombre: 'ANZÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '05045', Nombre: 'APARTADÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '05051', Nombre: 'ARBOLETES' },
    { Tipo: 'Municipio', CodigoDivipola: '05055', Nombre: 'ARGELIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05059', Nombre: 'ARMENIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05079', Nombre: 'BARBOSA' },
    { Tipo: 'Municipio', CodigoDivipola: '05086', Nombre: 'BELMIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '05088', Nombre: 'BELLO' },
    { Tipo: 'Municipio', CodigoDivipola: '05091', Nombre: 'BETANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05093', Nombre: 'BETULIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05101', Nombre: 'CIUDAD BOLÍVAR' },
    { Tipo: 'Municipio', CodigoDivipola: '05107', Nombre: 'BRICEÑO' },
    { Tipo: 'Municipio', CodigoDivipola: '05113', Nombre: 'BURITICÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '05120', Nombre: 'CÁCERES' },
    { Tipo: 'Municipio', CodigoDivipola: '05125', Nombre: 'CAICEDO' },
    { Tipo: 'Municipio', CodigoDivipola: '05129', Nombre: 'CALDAS' },
    { Tipo: 'Municipio', CodigoDivipola: '05134', Nombre: 'CAMPAMENTO' },
    { Tipo: 'Municipio', CodigoDivipola: '05138', Nombre: 'CAÑASGORDAS' },
    { Tipo: 'Municipio', CodigoDivipola: '05142', Nombre: 'CARACOLÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '05145', Nombre: 'CARAMANTA' },
    { Tipo: 'Municipio', CodigoDivipola: '05147', Nombre: 'CAREPA' },
    { Tipo: 'Municipio', CodigoDivipola: '05148', Nombre: 'EL CARMEN DE VIBORAL' },
    { Tipo: 'Municipio', CodigoDivipola: '05150', Nombre: 'CAROLINA' },
    { Tipo: 'Municipio', CodigoDivipola: '05154', Nombre: 'CAUCASIA' },
    { Tipo: 'Municipio', CodigoDivipola: '05172', Nombre: 'CHIGORODÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '05190', Nombre: 'CISNEROS' },
    { Tipo: 'Municipio', CodigoDivipola: '05197', Nombre: 'COCORNÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '05206', Nombre: 'CONCEPCIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '05209', Nombre: 'CONCORDIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18410', Nombre: 'LA MONTAÑITA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18460', Nombre: 'MILÁN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18479', Nombre: 'MORELIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18592', Nombre: 'PUERTO RICO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18610', Nombre: 'SAN JOSÉ DEL FRAGUA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18753', Nombre: 'SAN VICENTE DEL CAGUÁN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18756', Nombre: 'SOLANO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18785', Nombre: 'SOLITA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '18860', Nombre: 'VALPARAÍSO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '41020', Nombre: 'ALGECIRAS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '95015', Nombre: 'CALAMAR' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '95025', Nombre: 'EL RETORNO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '95200', Nombre: 'MIRAFLORES' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '95001', Nombre: 'SAN JOSÉ DEL GUAVIARE' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '50350', Nombre: 'LA MACARENA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '50325', Nombre: 'MAPIRIPÁN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '50330', Nombre: 'MESETAS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '50450', Nombre: 'PUERTO CONCORDIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '50577', Nombre: 'PUERTO LLERAS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '50590', Nombre: 'PUERTO RICO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '50370', Nombre: 'URIBE' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '50711', Nombre: 'VISTA HERMOSA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13212', Nombre: 'CÓRDOBA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13244', Nombre: 'EL CARMEN DE BOLÍVAR' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13248', Nombre: 'EL GUAMO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13442', Nombre: 'MARÍA LA BAJA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13654', Nombre: 'SAN JACINTO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13657', Nombre: 'SAN JUAN NEPOMUCENO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13894', Nombre: 'ZAMBRANO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '70230', Nombre: 'CHALÁN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '70204', Nombre: 'COLOSO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '70418', Nombre: 'LOS PALMITOS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '70473', Nombre: 'MORROA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '70508', Nombre: 'OVEJAS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '70523', Nombre: 'SAN ANTONIO DE PALMITO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '70713', Nombre: 'SAN ONOFRE' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '70823', Nombre: 'TOLÚ VIEJO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19318', Nombre: 'GUAPI' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19418', Nombre: 'LÓPEZ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '19809', Nombre: 'TIMBIQUÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '76109', Nombre: 'BUENAVENTURA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52079', Nombre: 'BARBACOAS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52250', Nombre: 'EL CHARCO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52520', Nombre: 'FRANCISCO PIZARRO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52390', Nombre: 'LA TOLA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52427', Nombre: 'MAGÜI' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52473', Nombre: 'MOSQUERA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52490', Nombre: 'OLAYA HERRERA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52612', Nombre: 'RICAURTE' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52621', Nombre: 'ROBERTO PAYÁN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52835', Nombre: 'SAN ANDRES DE TUMACO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '52696', Nombre: 'SANTA BÁRBARA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86573', Nombre: 'LEGUÍZAMO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86001', Nombre: 'MOCOA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86320', Nombre: 'ORITO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86568', Nombre: 'PUERTO ASÍS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86569', Nombre: 'PUERTO CAICEDO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86571', Nombre: 'PUERTO GUZMÁN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86757', Nombre: 'SAN MIGUEL' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86865', Nombre: 'VALLE DEL GUAMUEZ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '86885', Nombre: 'VILLAGARZÓN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '20013', Nombre: 'AGUSTÍN CODAZZI' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '20045', Nombre: 'BECERRIL' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '20400', Nombre: 'LA JAGUA DE IBIRICO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '20621', Nombre: 'LA PAZ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '20443', Nombre: 'MANAURE BALCÓN DEL CESAR' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '20570', Nombre: 'PUEBLO BELLO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '20750', Nombre: 'SAN DIEGO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '20001', Nombre: 'VALLEDUPAR' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '44090', Nombre: 'DIBULLA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '44279', Nombre: 'FONSECA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '44650', Nombre: 'SAN JUAN DEL CESAR' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '47053', Nombre: 'ARACATACA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '47189', Nombre: 'CIÉNAGA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '47288', Nombre: 'FUNDACIÓN' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '47001', Nombre: 'SANTA MARTA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13042', Nombre: 'ARENAL' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13160', Nombre: 'CANTAGALLO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13473', Nombre: 'MORALES' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13670', Nombre: 'SAN PABLO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13688', Nombre: 'SANTA ROSA DEL SUR' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '13744', Nombre: 'SIMITÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '23466', Nombre: 'MONTELÍBANO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '23580', Nombre: 'PUERTO LIBERTADOR' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '23682', Nombre: 'SAN JOSE DE URE' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '23807', Nombre: 'TIERRALTA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '23855', Nombre: 'VALENCIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '73067', Nombre: 'ATACO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '73168', Nombre: 'CHAPARRAL' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '73555', Nombre: 'PLANADAS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '73616', Nombre: 'RIOBLANCO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05893', Nombre: 'YONDÓ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05045', Nombre: 'APARTADÓ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05147', Nombre: 'CAREPA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05172', Nombre: 'CHIGORODÓ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05234', Nombre: 'DABEIBA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05480', Nombre: 'MUTATÁ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05490', Nombre: 'NECOCLÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05665', Nombre: 'SAN PEDRO DE URABA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05837', Nombre: 'TURBO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05031', Nombre: 'AMALFI' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05040', Nombre: 'ANORÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05107', Nombre: 'BRICEÑO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05120', Nombre: 'CÁCERES' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05154', Nombre: 'CAUCASIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05250', Nombre: 'EL BAGRE' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05361', Nombre: 'ITUANGO' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05495', Nombre: 'NECHÍ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05604', Nombre: 'REMEDIOS' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05736', Nombre: 'SEGOVIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05790', Nombre: 'TARAZÁ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05854', Nombre: 'VALDIVIA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05895', Nombre: 'ZARAGOZA' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05475', Nombre: 'MURINDÓ' },
    { Tipo: 'PdetMunicipio', CodigoDivipola: '05873', Nombre: 'VIGÍA DEL FUERTE' },
    { Tipo: 'Municipio', CodigoDivipola: '68001', Nombre: 'BUCARAMANGA' },
    { Tipo: 'Municipio', CodigoDivipola: '68013', Nombre: 'AGUADA' },
    { Tipo: 'Municipio', CodigoDivipola: '68020', Nombre: 'ALBANIA' },
    { Tipo: 'Municipio', CodigoDivipola: '68051', Nombre: 'ARATOCA' },
    { Tipo: 'Municipio', CodigoDivipola: '68077', Nombre: 'BARBOSA' },
    { Tipo: 'Municipio', CodigoDivipola: '68079', Nombre: 'BARICHARA' },
    { Tipo: 'Municipio', CodigoDivipola: '68081', Nombre: 'BARRANCABERMEJA' },
    { Tipo: 'Municipio', CodigoDivipola: '68092', Nombre: 'BETULIA' },
    { Tipo: 'Municipio', CodigoDivipola: '68101', Nombre: 'BOLÍVAR' },
    { Tipo: 'Municipio', CodigoDivipola: '68121', Nombre: 'CABRERA' },
    { Tipo: 'Municipio', CodigoDivipola: '68132', Nombre: 'CALIFORNIA' },
    { Tipo: 'Municipio', CodigoDivipola: '68147', Nombre: 'CAPITANEJO' },
    { Tipo: 'Municipio', CodigoDivipola: '68152', Nombre: 'CARCASÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '68160', Nombre: 'CEPITÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '68162', Nombre: 'CERRITO' },
    { Tipo: 'Municipio', CodigoDivipola: '68167', Nombre: 'CHARALÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '68169', Nombre: 'CHARTA' },
    { Tipo: 'Municipio', CodigoDivipola: '68176', Nombre: 'CHIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '68179', Nombre: 'CHIPATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '68190', Nombre: 'CIMITARRA' },
    { Tipo: 'Municipio', CodigoDivipola: '68207', Nombre: 'CONCEPCIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '68209', Nombre: 'CONFINES' },
    { Tipo: 'Municipio', CodigoDivipola: '68211', Nombre: 'CONTRATACIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '68217', Nombre: 'COROMORO' },
    { Tipo: 'Municipio', CodigoDivipola: '68229', Nombre: 'CURITÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '68235', Nombre: 'EL CARMEN DE CHUCURI' },
    { Tipo: 'Municipio', CodigoDivipola: '68245', Nombre: 'EL GUACAMAYO' },
    { Tipo: 'Municipio', CodigoDivipola: '68250', Nombre: 'EL PEÑÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '68255', Nombre: 'EL PLAYÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '68264', Nombre: 'ENCINO' },
    { Tipo: 'Municipio', CodigoDivipola: '68266', Nombre: 'ENCISO' },
    { Tipo: 'Municipio', CodigoDivipola: '68271', Nombre: 'FLORIÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '68276', Nombre: 'FLORIDABLANCA' },
    { Tipo: 'Municipio', CodigoDivipola: '68296', Nombre: 'GALÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '68298', Nombre: 'GÁMBITA' },
    { Tipo: 'Municipio', CodigoDivipola: '68307', Nombre: 'GIRÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '68318', Nombre: 'GUACA' },
    { Tipo: 'Municipio', CodigoDivipola: '68320', Nombre: 'GUADALUPE' },
    { Tipo: 'Municipio', CodigoDivipola: '68322', Nombre: 'GUAPOTÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '68324', Nombre: 'GUAVATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '68327', Nombre: 'GÜEPSA' },
    { Tipo: 'Municipio', CodigoDivipola: '68344', Nombre: 'HATO' },
    { Tipo: 'Municipio', CodigoDivipola: '68368', Nombre: 'JESÚS MARÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '68370', Nombre: 'JORDÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '68377', Nombre: 'LA BELLEZA' },
    { Tipo: 'Municipio', CodigoDivipola: '68385', Nombre: 'LANDÁZURI' },
    { Tipo: 'Municipio', CodigoDivipola: '68397', Nombre: 'LA PAZ' },
    { Tipo: 'Municipio', CodigoDivipola: '68406', Nombre: 'LEBRIJA' },
    { Tipo: 'Municipio', CodigoDivipola: '68418', Nombre: 'LOS SANTOS' },
    { Tipo: 'Municipio', CodigoDivipola: '68425', Nombre: 'MACARAVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '68432', Nombre: 'MÁLAGA' },
    { Tipo: 'Municipio', CodigoDivipola: '68444', Nombre: 'MATANZA' },
    { Tipo: 'Municipio', CodigoDivipola: '68464', Nombre: 'MOGOTES' },
    { Tipo: 'Municipio', CodigoDivipola: '68468', Nombre: 'MOLAGAVITA' },
    { Tipo: 'Municipio', CodigoDivipola: '68498', Nombre: 'OCAMONTE' },
    { Tipo: 'Municipio', CodigoDivipola: '68500', Nombre: 'OIBA' },
    { Tipo: 'Municipio', CodigoDivipola: '68502', Nombre: 'ONZAGA' },
    { Tipo: 'Municipio', CodigoDivipola: '68522', Nombre: 'PALMAR' },
    { Tipo: 'Municipio', CodigoDivipola: '68524', Nombre: 'PALMAS DEL SOCORRO' },
    { Tipo: 'Municipio', CodigoDivipola: '68533', Nombre: 'PÁRAMO' },
    { Tipo: 'Municipio', CodigoDivipola: '68547', Nombre: 'PIEDECUESTA' },
    { Tipo: 'Municipio', CodigoDivipola: '68549', Nombre: 'PINCHOTE' },
    { Tipo: 'Municipio', CodigoDivipola: '68572', Nombre: 'PUENTE NACIONAL' },
    { Tipo: 'Municipio', CodigoDivipola: '68573', Nombre: 'PUERTO PARRA' },
    { Tipo: 'Municipio', CodigoDivipola: '68575', Nombre: 'PUERTO WILCHES' },
    { Tipo: 'Municipio', CodigoDivipola: '68615', Nombre: 'RIONEGRO' },
    { Tipo: 'Municipio', CodigoDivipola: '68655', Nombre: 'SABANA DE TORRES' },
    { Tipo: 'Municipio', CodigoDivipola: '68669', Nombre: 'SAN ANDRÉS' },
    { Tipo: 'Municipio', CodigoDivipola: '68673', Nombre: 'SAN BENITO' },
    { Tipo: 'Municipio', CodigoDivipola: '68679', Nombre: 'SAN GIL' },
    { Tipo: 'Municipio', CodigoDivipola: '68682', Nombre: 'SAN JOAQUÍN' },
    { Tipo: 'Municipio', CodigoDivipola: '68684', Nombre: 'SAN JOSÉ DE MIRANDA' },
    { Tipo: 'Municipio', CodigoDivipola: '68686', Nombre: 'SAN MIGUEL' },
    { Tipo: 'Municipio', CodigoDivipola: '68689', Nombre: 'SAN VICENTE DE CHUCURÍ' },
    { Tipo: 'Municipio', CodigoDivipola: '68705', Nombre: 'SANTA BÁRBARA' },
    { Tipo: 'Municipio', CodigoDivipola: '68720', Nombre: 'SANTA HELENA DEL OPÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '68745', Nombre: 'SIMACOTA' },
    { Tipo: 'Municipio', CodigoDivipola: '68755', Nombre: 'SOCORRO' },
    { Tipo: 'Municipio', CodigoDivipola: '68770', Nombre: 'SUAITA' },
    { Tipo: 'Municipio', CodigoDivipola: '68773', Nombre: 'SUCRE' },
    { Tipo: 'Municipio', CodigoDivipola: '68780', Nombre: 'SURATÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '68820', Nombre: 'TONA' },
    { Tipo: 'Municipio', CodigoDivipola: '68855', Nombre: 'VALLE DE SAN JOSÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '68861', Nombre: 'VÉLEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '68867', Nombre: 'VETAS' },
    { Tipo: 'Municipio', CodigoDivipola: '68872', Nombre: 'VILLANUEVA' },
    { Tipo: 'Municipio', CodigoDivipola: '68895', Nombre: 'ZAPATOCA' },
    { Tipo: 'Municipio', CodigoDivipola: '70001', Nombre: 'SINCELEJO' },
    { Tipo: 'Municipio', CodigoDivipola: '70110', Nombre: 'BUENAVISTA' },
    { Tipo: 'Municipio', CodigoDivipola: '70124', Nombre: 'CAIMITO' },
    { Tipo: 'Municipio', CodigoDivipola: '70204', Nombre: 'COLOSÓ' },
    { Tipo: 'Municipio', CodigoDivipola: '70215', Nombre: 'COROZAL' },
    { Tipo: 'Municipio', CodigoDivipola: '70221', Nombre: 'COVEÑAS' },
    { Tipo: 'Municipio', CodigoDivipola: '70230', Nombre: 'CHALÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '70233', Nombre: 'EL ROBLE' },
    { Tipo: 'Municipio', CodigoDivipola: '70235', Nombre: 'GALERAS' },
    { Tipo: 'Municipio', CodigoDivipola: '70265', Nombre: 'GUARANDA' },
    { Tipo: 'Municipio', CodigoDivipola: '70400', Nombre: 'LA UNIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '70418', Nombre: 'LOS PALMITOS' },
    { Tipo: 'Municipio', CodigoDivipola: '70429', Nombre: 'MAJAGUAL' },
    { Tipo: 'Municipio', CodigoDivipola: '70473', Nombre: 'MORROA' },
    { Tipo: 'Municipio', CodigoDivipola: '70508', Nombre: 'OVEJAS' },
    { Tipo: 'Municipio', CodigoDivipola: '70523', Nombre: 'PALMITO' },
    { Tipo: 'Municipio', CodigoDivipola: '70670', Nombre: 'SAMPUÉS' },
    { Tipo: 'Municipio', CodigoDivipola: '70678', Nombre: 'SAN BENITO ABAD' },
    { Tipo: 'Municipio', CodigoDivipola: '70702', Nombre: 'SAN JUAN DE BETULIA' },
    { Tipo: 'Municipio', CodigoDivipola: '70708', Nombre: 'SAN MARCOS' },
    { Tipo: 'Municipio', CodigoDivipola: '70713', Nombre: 'SAN ONOFRE' },
    { Tipo: 'Municipio', CodigoDivipola: '70717', Nombre: 'SAN PEDRO' },
    { Tipo: 'Municipio', CodigoDivipola: '70742', Nombre: 'SAN LUIS DE SINCÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '70771', Nombre: 'SUCRE' },
    { Tipo: 'Municipio', CodigoDivipola: '70820', Nombre: 'SANTIAGO DE TOLÚ' },
    { Tipo: 'Municipio', CodigoDivipola: '70823', Nombre: 'SAN JOSÉ DE TOLUVIEJO' },
    { Tipo: 'Municipio', CodigoDivipola: '73001', Nombre: 'IBAGUÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '73024', Nombre: 'ALPUJARRA' },
    { Tipo: 'Municipio', CodigoDivipola: '73026', Nombre: 'ALVARADO' },
    { Tipo: 'Municipio', CodigoDivipola: '73030', Nombre: 'AMBALEMA' },
    { Tipo: 'Municipio', CodigoDivipola: '73043', Nombre: 'ANZOÁTEGUI' },
    { Tipo: 'Municipio', CodigoDivipola: '73055', Nombre: 'ARMERO' },
    { Tipo: 'Municipio', CodigoDivipola: '73067', Nombre: 'ATACO' },
    { Tipo: 'Municipio', CodigoDivipola: '73124', Nombre: 'CAJAMARCA' },
    { Tipo: 'Municipio', CodigoDivipola: '73148', Nombre: 'CARMEN DE APICALÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '73152', Nombre: 'CASABIANCA' },
    { Tipo: 'Municipio', CodigoDivipola: '73168', Nombre: 'CHAPARRAL' },
    { Tipo: 'Municipio', CodigoDivipola: '73200', Nombre: 'COELLO' },
    { Tipo: 'Municipio', CodigoDivipola: '73217', Nombre: 'COYAIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '73226', Nombre: 'CUNDAY' },
    { Tipo: 'Municipio', CodigoDivipola: '73236', Nombre: 'DOLORES' },
    { Tipo: 'Municipio', CodigoDivipola: '73268', Nombre: 'ESPINAL' },
    { Tipo: 'Municipio', CodigoDivipola: '73270', Nombre: 'FALAN' },
    { Tipo: 'Municipio', CodigoDivipola: '73275', Nombre: 'FLANDES' },
    { Tipo: 'Municipio', CodigoDivipola: '73283', Nombre: 'FRESNO' },
    { Tipo: 'Municipio', CodigoDivipola: '73319', Nombre: 'GUAMO' },
    { Tipo: 'Municipio', CodigoDivipola: '73347', Nombre: 'HERVEO' },
    { Tipo: 'Municipio', CodigoDivipola: '73349', Nombre: 'HONDA' },
    { Tipo: 'Municipio', CodigoDivipola: '73352', Nombre: 'ICONONZO' },
    { Tipo: 'Municipio', CodigoDivipola: '73408', Nombre: 'LÉRIDA' },
    { Tipo: 'Municipio', CodigoDivipola: '73411', Nombre: 'LÍBANO' },
    { Tipo: 'Municipio', CodigoDivipola: '73443', Nombre: 'SAN SEBASTIÁN DE MARIQUITA' },
    { Tipo: 'Municipio', CodigoDivipola: '73449', Nombre: 'MELGAR' },
    { Tipo: 'Municipio', CodigoDivipola: '73461', Nombre: 'MURILLO' },
    { Tipo: 'Municipio', CodigoDivipola: '73483', Nombre: 'NATAGAIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '73504', Nombre: 'ORTEGA' },
    { Tipo: 'Municipio', CodigoDivipola: '73520', Nombre: 'PALOCABILDO' },
    { Tipo: 'Municipio', CodigoDivipola: '73547', Nombre: 'PIEDRAS' },
    { Tipo: 'Municipio', CodigoDivipola: '73555', Nombre: 'PLANADAS' },
    { Tipo: 'Municipio', CodigoDivipola: '73563', Nombre: 'PRADO' },
    { Tipo: 'Municipio', CodigoDivipola: '73585', Nombre: 'PURIFICACIÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '73616', Nombre: 'RIOBLANCO' },
    { Tipo: 'Municipio', CodigoDivipola: '73622', Nombre: 'RONCESVALLES' },
    { Tipo: 'Municipio', CodigoDivipola: '73624', Nombre: 'ROVIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '73671', Nombre: 'SALDAÑA' },
    { Tipo: 'Municipio', CodigoDivipola: '73675', Nombre: 'SAN ANTONIO' },
    { Tipo: 'Municipio', CodigoDivipola: '73678', Nombre: 'SAN LUIS' },
    { Tipo: 'Municipio', CodigoDivipola: '73686', Nombre: 'SANTA ISABEL' },
    { Tipo: 'Municipio', CodigoDivipola: '73770', Nombre: 'SUÁREZ' },
    { Tipo: 'Municipio', CodigoDivipola: '73854', Nombre: 'VALLE DE SAN JUAN' },
    { Tipo: 'Municipio', CodigoDivipola: '73861', Nombre: 'VENADILLO' },
    { Tipo: 'Municipio', CodigoDivipola: '73870', Nombre: 'VILLAHERMOSA' },
    { Tipo: 'Municipio', CodigoDivipola: '73873', Nombre: 'VILLARRICA' },
    { Tipo: 'Municipio', CodigoDivipola: '76001', Nombre: 'CALI' },
    { Tipo: 'Municipio', CodigoDivipola: '76020', Nombre: 'ALCALÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '76036', Nombre: 'ANDALUCÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '76041', Nombre: 'ANSERMANUEVO' },
    { Tipo: 'Municipio', CodigoDivipola: '76054', Nombre: 'ARGELIA' },
    { Tipo: 'Municipio', CodigoDivipola: '76100', Nombre: 'BOLÍVAR' },
    { Tipo: 'Municipio', CodigoDivipola: '76109', Nombre: 'BUENAVENTURA' },
    { Tipo: 'Municipio', CodigoDivipola: '76111', Nombre: 'GUADALAJARA DE BUGA' },
    { Tipo: 'Municipio', CodigoDivipola: '76113', Nombre: 'BUGALAGRANDE' },
    { Tipo: 'Municipio', CodigoDivipola: '76122', Nombre: 'CAICEDONIA' },
    { Tipo: 'Municipio', CodigoDivipola: '76126', Nombre: 'CALIMA' },
    { Tipo: 'Municipio', CodigoDivipola: '76130', Nombre: 'CANDELARIA' },
    { Tipo: 'Municipio', CodigoDivipola: '76147', Nombre: 'CARTAGO' },
    { Tipo: 'Municipio', CodigoDivipola: '76233', Nombre: 'DAGUA' },
    { Tipo: 'Municipio', CodigoDivipola: '76243', Nombre: 'EL ÁGUILA' },
    { Tipo: 'Municipio', CodigoDivipola: '76246', Nombre: 'EL CAIRO' },
    { Tipo: 'Municipio', CodigoDivipola: '76248', Nombre: 'EL CERRITO' },
    { Tipo: 'Municipio', CodigoDivipola: '76250', Nombre: 'EL DOVIO' },
    { Tipo: 'Municipio', CodigoDivipola: '76275', Nombre: 'FLORIDA' },
    { Tipo: 'Municipio', CodigoDivipola: '86219', Nombre: 'COLÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '86320', Nombre: 'ORITO' },
    { Tipo: 'Municipio', CodigoDivipola: '86568', Nombre: 'PUERTO ASÍS' },
    { Tipo: 'Municipio', CodigoDivipola: '86569', Nombre: 'PUERTO CAICEDO' },
    { Tipo: 'Municipio', CodigoDivipola: '86571', Nombre: 'PUERTO GUZMÁN' },
    { Tipo: 'Municipio', CodigoDivipola: '86573', Nombre: 'PUERTO LEGUÍZAMO' },
    { Tipo: 'Municipio', CodigoDivipola: '86749', Nombre: 'SIBUNDOY' },
    { Tipo: 'Municipio', CodigoDivipola: '86755', Nombre: 'SAN FRANCISCO' },
    { Tipo: 'Municipio', CodigoDivipola: '86757', Nombre: 'SAN MIGUEL' },
    { Tipo: 'Municipio', CodigoDivipola: '86760', Nombre: 'SANTIAGO' },
    { Tipo: 'Municipio', CodigoDivipola: '86865', Nombre: 'VALLE DEL GUAMUEZ' },
    { Tipo: 'Municipio', CodigoDivipola: '86885', Nombre: 'VILLAGARZÓN' },
    { Tipo: 'Municipio', CodigoDivipola: '88001', Nombre: 'SAN ANDRÉS' },
    { Tipo: 'Municipio', CodigoDivipola: '88564', Nombre: 'PROVIDENCIA' },
    { Tipo: 'Municipio', CodigoDivipola: '91001', Nombre: 'LETICIA' },
    { Tipo: 'Municipio', CodigoDivipola: '91263', Nombre: 'EL ENCANTO' },
    { Tipo: 'Municipio', CodigoDivipola: '91405', Nombre: 'LA CHORRERA' },
    { Tipo: 'Municipio', CodigoDivipola: '91407', Nombre: 'LA PEDRERA' },
    { Tipo: 'Municipio', CodigoDivipola: '91430', Nombre: 'LA VICTORIA' },
    { Tipo: 'Municipio', CodigoDivipola: '91460', Nombre: 'MIRITÍ - PARANÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '91530', Nombre: 'PUERTO ALEGRÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '91536', Nombre: 'PUERTO ARICA' },
    { Tipo: 'Municipio', CodigoDivipola: '91540', Nombre: 'PUERTO NARIÑO' },
    { Tipo: 'Municipio', CodigoDivipola: '91669', Nombre: 'PUERTO SANTANDER' },
    { Tipo: 'Municipio', CodigoDivipola: '91798', Nombre: 'TARAPACÁ' },
    { Tipo: 'Municipio', CodigoDivipola: '94001', Nombre: 'INÍRIDA' },
    { Tipo: 'Municipio', CodigoDivipola: '94343', Nombre: 'BARRANCOMINAS' },
    { Tipo: 'Municipio', CodigoDivipola: '94883', Nombre: 'SAN FELIPE' },
    { Tipo: 'Municipio', CodigoDivipola: '94884', Nombre: 'PUERTO COLOMBIA' },
    { Tipo: 'Municipio', CodigoDivipola: '94885', Nombre: 'LA GUADALUPE' },
    { Tipo: 'Municipio', CodigoDivipola: '94886', Nombre: 'CACAHUAL' },
    { Tipo: 'Municipio', CodigoDivipola: '94887', Nombre: 'PANA PANA' },
    { Tipo: 'Municipio', CodigoDivipola: '94888', Nombre: 'MORICHAL' },
    { Tipo: 'Municipio', CodigoDivipola: '95001', Nombre: 'SAN JOSÉ DEL GUAVIARE' },
    { Tipo: 'Municipio', CodigoDivipola: '95015', Nombre: 'CALAMAR' },
    { Tipo: 'Municipio', CodigoDivipola: '95025', Nombre: 'EL RETORNO' },
    { Tipo: 'Municipio', CodigoDivipola: '95200', Nombre: 'MIRAFLORES' },
    { Tipo: 'Municipio', CodigoDivipola: '97001', Nombre: 'MITÚ' },
    { Tipo: 'Municipio', CodigoDivipola: '97161', Nombre: 'CARURÚ' },
    { Tipo: 'Municipio', CodigoDivipola: '97511', Nombre: 'PACOA' },
    { Tipo: 'Municipio', CodigoDivipola: '97666', Nombre: 'TARAIRA' },
    { Tipo: 'Municipio', CodigoDivipola: '97777', Nombre: 'PAPUNAHUA' },
    { Tipo: 'Municipio', CodigoDivipola: '97889', Nombre: 'YAVARATÉ' },
    { Tipo: 'Municipio', CodigoDivipola: '99001', Nombre: 'PUERTO CARREÑO' },
    { Tipo: 'Municipio', CodigoDivipola: '99524', Nombre: 'LA PRIMAVERA' },
    { Tipo: 'Municipio', CodigoDivipola: '99624', Nombre: 'SANTA ROSALÍA' },
    { Tipo: 'Municipio', CodigoDivipola: '99773', Nombre: 'CUMARIBO' },
    { Tipo: 'Municipio', CodigoDivipola: '05001', Nombre: 'MEDELLÍN' },
];